var roomvoExport = (() => {
  var _o = (e) => {
      let t = document.createElement('a');
      t.href = e;
      let o = t.pathname;
      return o.length > 0 && o[0] != '/' && (o = '/' + o), o;
    },
    Re = (e) => {
      let t = document.createElement('a');
      return (t.href = e), t.hostname;
    },
    y = () => (window.roomvoLocation ? window.roomvoLocation : window.location),
    fe = (e) => _o(decodeURIComponent(e.href)),
    Oe = (e) =>
      fe(e)
        .replace(/(^\/)|(\/$)/g, '')
        .split('/');
  var Ze = (e) => {
    let t = Oe(e);
    return t[t.length - 1];
  };
  var Xe = (e, t) => new URL(e.href).searchParams.get(t);
  var g = new (class {
    getUrl() {
      return new URL(window.location.href);
    }
    getNextLevelUrl() {
      try {
        return new URL(window.parent.location.href);
      } catch {}
      return window.location.ancestorOrigins && window.location.ancestorOrigins.item(0)
        ? new URL(window.location.ancestorOrigins.item(0))
        : document.referrer
        ? new URL(document.referrer)
        : null;
    }
    getTopLevelUrl() {
      try {
        return new URL(window.top.location.href);
      } catch {}
      return window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0
        ? new URL(window.location.ancestorOrigins[window.location.ancestorOrigins.length - 1])
        : document.referrer
        ? new URL(document.referrer)
        : null;
    }
    getHostname() {
      let e = this.getUrl();
      return e ? e.hostname : '';
    }
    getNextLevelHostname() {
      let e = this.getNextLevelUrl();
      return e ? e.hostname : '';
    }
    getTopLevelHostname() {
      let e = this.getTopLevelUrl();
      return e ? e.hostname : '';
    }
  })();
  var Je = 'roomvo-button',
    M = 'roomvo-lite-iframe';
  var K = 'roomvo-product-display-button',
    Qe = 'roomvo-measure-my-room-button';
  var F = 'ffPopup';
  var mo = 'roomvoProductCatalog',
    To = 'roomvoProductDisplay',
    w = mo,
    et = To;
  var f = F,
    Po = 'roomvoMeasurement';
  var N = 'roomvo-stimr',
    tt = 'roomvo-designer';
  var q = 'roomvo_add_to_cart',
    U = 0,
    Eo = 1,
    ho = 2,
    Ro = 3,
    fo = 4,
    ot = 5,
    Oo = 6,
    Co = 7,
    Uo = 8,
    go = 9,
    So = 10,
    Io = 11,
    Ao = 12,
    yo = 13,
    Ce = 0,
    Lo = 1,
    xo = 2,
    Ue = 0,
    ge = 1,
    Do = 2;
  var rt = 'full',
    nt = 'lite',
    st = 'multiple',
    it = 'Product Detail',
    at = 'Product List',
    ct = 'Home',
    lt = 'Standalone Visualizer',
    dt = 'Shopping Cart';
  var pt = 'Purchase Confirmation',
    ut = 'Other',
    Se = 'ffvendorids',
    Ie = 'ffvisitorids';
  var Ae = 'ffvendorurlpath',
    W = 'fftrackingcode',
    j = 'ffagreedtermsofuse',
    ye = 'roomvoLaunchSequenceRecentUseFlag',
    $ = 'roomvoLaunchSequence';
  var Z = 'roomvoLite',
    _t = 'surfaceDesigner',
    mt = [Po, f],
    X = {
      [U]: 'unknown',
      [Eo]: 'floor',
      [ho]: 'rug',
      [Ro]: 'furniture',
      [fo]: 'countertop',
      [ot]: 'wall',
      [Oo]: 'cabinet',
      [Co]: 'wall_decor',
      [Uo]: 'ceiling',
      [go]: 'door',
      [So]: 'trim',
      [Io]: 'furniture_coating',
      [Ao]: 'roof',
      [yo]: 'radiator',
    },
    Tt = {
      'en-us': {
        'Embed this Roomvo share link on your website': 'Embed this Roomvo share link on your website',
        'Share Product': 'Share Product',
        Copy: 'Copy',
        Close: 'Close',
        'Loading...': 'Loading...',
      },
    },
    Wa = { [Ce]: 'none', [Lo]: 'standalone', [xo]: 'product_integration' },
    $a = { [Ue]: 'desktop', [ge]: 'touch', [Do]: 'kiosk' };
  var Pt = 'Viewed Host Page';
  var P = {
    LOAD_POPUP_FROM_ASSISTANT: 'roomvoLoadPopupFromAssistant',
    ENLARGE_ASSISTANT_POPUP: 'roomvoEnlargeAssistantPopup',
    REDUCE_ASSISTANT_POPUP: 'roomvoReduceAssistantPopup',
    OPEN_PRODUCT_VISUALIZER: 'roomvoOpenProductVisualizer',
    RESIZE_CATALOG: 'roomvoResizeCatalog',
    OPEN_PRODUCT_PAGE: 'roomvoOpenProductPage',
    OPEN_CATALOG: 'roomvoOpenCatalog',
    REQUEST_ESTIMATE: 'roomvoRequestEstimate',
    SAVE_VISITOR: 'ffSaveVisitor',
    FOCUS_POPUP: 'ffFocusPopup',
    CLOSE_PRODUCT_DISPLAY: 'roomvoCloseProductDisplay',
    AGREE_TO_TERMS_OF_USE: 'roomvoAgreeToTermsOfUse',
    ADD_TO_FAVORITES: 'roomvoAddToFavorites',
    REMOVE_FROM_FAVORITES: 'roomvoRemoveFromFavorites',
    ADD_TO_CART: 'roomvoAddToCart',
    ORDER_SAMPLE: 'roomvoOrderSample',
    RESERVE_ONLINE_PICKUP_IN_STORE: 'roomvoReserveOnlinePickupInStore',
    SUBMIT_PAYMENT: 'roomvoSubmitPayment',
    HANDLE_BOOK_APPOINTMENT: 'roomvoHandleBookAppointment',
    RESIZE_CONTACT_FORM: 'roomvoResizeContactForm',
    CLICK_PRODUCT_LINK: 'roomvoClickProductLink',
    LOAD_POPUP_FROM_PRODUCT_DISPLAY: 'roomvoLoadPopupFromProductDisplay',
    CLICK_BOOK_APPOINTMENT: 'roomvoClickBookAppointment',
    INITIATE_CUSTOM_ACTION: 'roomvoInitiateCustomAction',
    PROPAGATE_SESSION: 'roomvoPropagateSession',
    HANDLE_LEAD: 'roomvoHandleLead',
    RESIZE_STORE_LOCATOR_IFRAME: 'resizeStoreLocatorIframe',
    TRACK: 'ffTrack',
    FOCUS_IFRAME: 'roomvoFocusIframe',
    CLOSE_LAUNCH_SEQUENCE: 'roomvoCloseLaunchSequence',
    OPEN_MEASUREMENT: 'roomvoOpenMeasurement',
    CLOSE_MEASUREMENT: 'roomvoCloseMeasurement',
    UPDATE_PRODUCT_FILTER: 'roomvoUpdateProductFilter',
    SCROLL_TOP_OF_IFRAME_INTO_VIEW: 'roomvoScrollTopOfIframeIntoView',
    EXPAND_ROOM_PAGE_LITE: 'roomvoRoomPageLiteExpand',
    SHRINK_ROOM_PAGE_LITE: 'roomvoRoomPageLiteShrink',
    SWIPE_ROOM_PAGE_LITE: 'roomvoRoomPageLiteSwipe',
    MEASURE_RESULT: 'roomvoMeasureResult',
    CLICK_FIND_SELLER: 'roomvoClickFindSeller',
    UPDATE_SHOPPING_CART: 'roomvoUpdateShoppingCart',
    CLOSE_VISUALIZER: 'roomvoCloseVisualizer',
    NOTIFY_ROOM_PAGE_LITE_LOADED: 'roomvoNotifyRoomPageLiteLoaded',
    TRACK_PRODUCT_USAGE_EVENT_FOR_LITE: 'roomvoTrackProductUsageEventForLite',
    TRACK_PRODUCT_IMPRESSION_EVENT_FOR_LITE: 'roomvoTrackProductImpressionEventForLite',
    TRACK_ROOM_PAGE_VIEW_FOR_LITE: 'roomvoTrackRoomPageViewForLite',
    CHANGE_PRODUCT_CODE_IN_LITE: 'roomvoRoomPageLiteChangeProduct',
    NOTIFY_ROOM_PAGE_LITE_PRODUCT_UPDATED: 'roomvoRoomPageLiteProductUpdated',
    DOWNLOAD_VISUALIZED_ROOM_IMAGE: 'roomvoDownloadVisualizedRoomImage',
    NOTIFY_GENERATED_RESTYLE_LITE_ROOM: 'roomvoNotifyGeneratedRestyleLiteRoom',
    NOTIFY_HOVER_ENTER_RESTYLE_LITE: 'roomvoNotifyHoverEnterRestyleLite',
    NOTIFY_HOVER_LEAVE_RESTYLE_LITE: 'roomvoNotifyHoverLeaveRestyleLite',
    OPEN_CHATBOT: 'roomvoOpenChatbot',
    CLOSE_CHATBOT: 'roomvoCloseChatbot',
    ADD_MESSAGE_TO_CHATBOT_THREAD: 'roomvoAddMessageToChatbotThread',
    OPEN_RELATIVE_URL: 'roomvoOpenRelativeUrl',
    NOTIFY_CHATBOT_LAUNCHER_LOADED: 'roomvoNotifyChatbotLauncherLoaded',
    NOTIFY_CHATBOT_LOADED: 'roomvoNotifyChatbotLoaded',
    START_CHATBOT_LAUNCHER_LAUNCH_ANIMATION: 'roomvoStartChatbotLauncherLaunchAnimation',
  };
  var wo = [
      'roomvo',
      'googlebot',
      'bingbot',
      'ahrefsbot',
      'semrushbot',
      'siteauditbot',
      'facebookexternalhit',
      'twitter',
      'linkedin',
      'pinterest',
    ],
    vo = (e) => e && /iPad|iPhone|iPod/.test(e.userAgent),
    bo = (e) => e && e.userAgent.includes('Macintosh; Intel Mac OS X');
  var No = (e) =>
    !!(
      e &&
      (e.platform === 'MacIntel' || e.platform === 'iPad' || e.platform === 'iPhone' || e.platform === 'iPod' || bo(e))
    );
  var Bo = (e) => !!(No(e) && e.maxTouchPoints > 1),
    Yo = (e) => !!(!window.MSStream && (vo(e) || Bo(e)));
  var Et = (e) => (e ? e.userAgent.indexOf('MSIE') > 0 || e.userAgent.indexOf('Trident/') > -1 : !1);
  var ht = (e) =>
    !e || RegExp(wo.join('|'), 'i').test(e.userAgent)
      ? !1
      : new RegExp(
          [
            'bot|googlebot|googleweblight|spider|robot|crawl|baidu|bing|msn',
            '|duckduckgo|teoma|slurp|yandex|lighthouse|sitecrawl|linguee',
            '|schemabot|indeedbot|opendi|optimizer|nssprerendersproxy',
            '|headlesschrome|ghostsinspector|restsharp|woorankreview|screamingfrogseospider',
          ].join(''),
          'i'
        ).test(e.userAgent);
  var Mo = new RegExp(
      [
        '(android|bb\\d+|meego).+mobile|avantgo|bada/|blackberry',
        '|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp',
        '|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)/|plucker',
        '|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows ce|xda',
        '|xiino|android|ipad|playbook|silk',
      ].join(''),
      'i'
    ),
    Le = function () {
      let e = !1;
      return (
        (function (t) {
          let o = new RegExp(
            [
              '1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s',
              '|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu',
              '|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)',
              '|br(e|v)w|bumb|bw-(n|u)|c55/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw',
              '|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)',
              '|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo',
              '|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c',
              '|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|/)|ibro|idea',
              '|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |/)|klon',
              '|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|/(k|l|u)|50|54|-[a-w])|libw|lynx',
              '|m1-w|m3ga|m50/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef',
              '|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]',
              '|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph',
              '|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire',
              '|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)',
              '|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)',
              '|sdk/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3',
              '|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)',
              '|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)',
              '|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61',
              '|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-',
              '|your|zeto|zte-',
            ].join(''),
            'i'
          );
          e = t ? Mo.test(t) || o.test(t.substring(0, 4)) : !1;
        })(navigator.userAgent || navigator.vendor || window.opera),
        e || Yo(window.navigator) ? ge : Ue
      );
    };
  var xe = (e) => {
    for (let t in e) if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return B(e) === B({});
  };
  var L = (e, t, o) => {
    let r;
    return function () {
      let n = this,
        s = arguments,
        i = o && !r;
      clearTimeout(r),
        (r = setTimeout(function () {
          (r = null), o || e.apply(n, s);
        }, t)),
        i && e.apply(n, s);
    };
  };
  var B = (e) => (!JSON.stringify && JSON.serialize ? JSON.serialize(e) : JSON.stringify(e)),
    J = (e) => (!JSON.parse && JSON.deserialize ? JSON.deserialize(e) : JSON.parse(e));
  var Q = (e) => Fo()[e],
    Fo = () => {
      let e = {},
        t = document.cookie.split(';');
      for (let o = 0; o < t.length; ++o) {
        let r = t[o].trim(),
          n = r.indexOf('=');
        if (n !== -1) {
          let s = r.substring(0, r.indexOf('=')),
            i = r.substring(n + 1);
          e[s] = i;
        }
      }
      return e;
    },
    Rt = (e) => Q(e) !== void 0,
    De = (e, t, o = {}) => {
      let r = o.cookieExpiration ? o.cookieExpiration : 'Fri, 31 Dec 9999 23:59:59 GMT',
        n = [`${e}=${t}`, `expires=${r}`, 'path=/', o.sameSitePolicy || `${ko()}`];
      o.domain && n.push(`domain=${o.domain}`), (document.cookie = n.join('; '));
    };
  var ko = () => (g.getUrl().protocol === 'https:' ? 'SameSite=None; Secure' : 'SameSite=Lax');
  var d = function (e, t) {
    try {
      e.log.length + t.length < 1e6
        ? (e.log +=
            t +
            `
`)
        : e.log.endsWith(`.....
`) ||
          (e.log += `.....
`);
    } catch (o) {
      e.log = o.toString();
    }
  };
  var O = (e, t, o) => {
    if (!e.isRoomvoCookieDisabled()) {
      let r = { cookieExpiration: e.getCookieExpiration(), domain: e.getCookieDomain() },
        { cookieName: n, cookieValue: s, config: i = {} } = o,
        a = Object.assign({}, r, i);
      switch (t.toLowerCase()) {
        case 'write':
          return De(n, s, a);
        case 'read':
          return Q(n);
        case 'read/rewrite': {
          let c = Q(n);
          return c && De(n, c, a), c;
        }
        case 'check':
          return Rt(n);
      }
    }
    return d(e, 'Accessing cookies is not permitted.'), null;
  };
  var ft = (e, t) => {
      O(t, 'check', { cookieName: W }) ||
        (Math.random() < 0.5
          ? O(t, 'write', { cookieName: W, cookieValue: 'dontshow', config: { cookieExpiration: e } })
          : O(t, 'write', { cookieName: W, cookieValue: 'show', config: { cookieExpiration: e } }));
    },
    v = (e) => O(e, 'read', { cookieName: W }) || '';
  var ee = (e) => e.toString() === '[object RoomvoIntegrator]',
    h = (e) => {
      let t = Object.values(window._roomvo).filter((o) => o.toString().endsWith('Integrator]'));
      return e
        ? window._roomvo[e] || t.find((o) => o.toString() === '[object AssistantIntegrator]') || t.find(ee) || t[0]
        : t.find(ee) || t[0];
    };
  var Go = `
<svg
class="loader-cubes__cube loader-cubes__one"
width="82"
height="76"
viewBox="0 0 82 76"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<g opacity="0.6" filter="url(#filter0_f_557_14053)">
  <path
    class="cube__shadow"
    d="M41.0002 32.0018L62.0001 43.9996L41.0002 56.0002L20.0315 43.9994L41.0002 32.0018Z"
  ></path>
</g>
<path
  class="cube__left-side"
  d="M41 12.1838L62 12.0002L62 20.9651L41 33L19.9999 20.9652L19.9999 12.0003L41 12.1838Z"
></path>
<path
  class="cube__right-side"
  d="M41.0002 23.9998L62.0004 12.0054L62.0004 20.9594L40.9998 33L41.0002 23.9998Z"
></path>
<path
  class="cube__top"
  d="M41.0002 0.00178922L62.0001 11.9996L41.0002 24.0002L20.0315 11.9994L41.0002 0.00178922Z"
></path>
<defs>
  <filter
    id="filter0_f_557_14053"
    x="0.03125"
    y="12.002"
    width="81.9688"
    height="63.998"
    filterUnits="userSpaceOnUse"
    color-interpolation-filters="sRGB"
  >
    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
    <feBlend
      mode="normal"
      in="SourceGraphic"
      in2="BackgroundImageFix"
      result="shape"
    ></feBlend>
    <feGaussianBlur
      stdDeviation="10"
      result="effect1_foregroundBlur_557_14053"
    ></feGaussianBlur>
  </filter>
</defs>
</svg>
<svg
class="loader-cubes__cube loader-cubes__three"
width="82"
height="76"
viewBox="0 0 82 76"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<g opacity="0.6" filter="url(#filter0_f_557_14053)">
  <path
    class="cube__shadow"
    d="M41.0002 32.0018L62.0001 43.9996L41.0002 56.0002L20.0315 43.9994L41.0002 32.0018Z"
  ></path>
</g>
<path
  class="cube__left-side"
  d="M41 12.1838L62 12.0002L62 20.9651L41 33L19.9999 20.9652L19.9999 12.0003L41 12.1838Z"
></path>
<path
  class="cube__right-side"
  d="M41.0002 23.9998L62.0004 12.0054L62.0004 20.9594L40.9998 33L41.0002 23.9998Z"
></path>
<path
  class="cube__top"
  d="M41.0002 0.00178922L62.0001 11.9996L41.0002 24.0002L20.0315 11.9994L41.0002 0.00178922Z"
></path>
<defs>
  <filter
    id="filter0_f_557_14053"
    x="0.03125"
    y="12.002"
    width="81.9688"
    height="63.998"
    filterUnits="userSpaceOnUse"
    color-interpolation-filters="sRGB"
  >
    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
    <feBlend
      mode="normal"
      in="SourceGraphic"
      in2="BackgroundImageFix"
      result="shape"
    ></feBlend>
    <feGaussianBlur
      stdDeviation="10"
      result="effect1_foregroundBlur_557_14053"
    ></feGaussianBlur>
  </filter>
</defs>
</svg>
<svg
class="loader-cubes__cube loader-cubes__two"
width="82"
height="76"
viewBox="0 0 82 76"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<g opacity="0.6" filter="url(#filter0_f_557_14053)">
  <path
    class="cube__shadow"
    d="M41.0002 32.0018L62.0001 43.9996L41.0002 56.0002L20.0315 43.9994L41.0002 32.0018Z"
  ></path>
</g>
<path
  class="cube__left-side"
  d="M41 12.1838L62 12.0002L62 20.9651L41 33L19.9999 20.9652L19.9999 12.0003L41 12.1838Z"
></path>
<path
  class="cube__right-side"
  d="M41.0002 23.9998L62.0004 12.0054L62.0004 20.9594L40.9998 33L41.0002 23.9998Z"
></path>
<path
  class="cube__top"
  d="M41.0002 0.00178922L62.0001 11.9996L41.0002 24.0002L20.0315 11.9994L41.0002 0.00178922Z"
></path>
<defs>
  <filter
    id="filter0_f_557_14053"
    x="0.03125"
    y="12.002"
    width="81.9688"
    height="63.998"
    filterUnits="userSpaceOnUse"
    color-interpolation-filters="sRGB"
  >
    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
    <feBlend
      mode="normal"
      in="SourceGraphic"
      in2="BackgroundImageFix"
      result="shape"
    ></feBlend>
    <feGaussianBlur
      stdDeviation="10"
      result="effect1_foregroundBlur_557_14053"
    ></feGaussianBlur>
  </filter>
</defs>
</svg>
<svg
class="loader-cubes__cube loader-cubes__four"
width="82"
height="76"
viewBox="0 0 82 76"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<g opacity="0.6" filter="url(#filter0_f_557_14053)">
  <path
    class="cube__shadow"
    d="M41.0002 32.0018L62.0001 43.9996L41.0002 56.0002L20.0315 43.9994L41.0002 32.0018Z"
  ></path>
</g>
<path
  class="cube__left-side"
  d="M41 12.1838L62 12.0002L62 20.9651L41 33L19.9999 20.9652L19.9999 12.0003L41 12.1838Z"
></path>
<path
  class="cube__right-side"
  d="M41.0002 23.9998L62.0004 12.0054L62.0004 20.9594L40.9998 33L41.0002 23.9998Z"
  fill="#828BA4"
></path>
<path
  class="cube__top"
  d="M41.0002 0.00178922L62.0001 11.9996L41.0002 24.0002L20.0315 11.9994L41.0002 0.00178922Z"
></path>
<defs>
  <filter
    id="filter0_f_557_14053"
    x="0.03125"
    y="12.002"
    width="81.9688"
    height="63.998"
    filterUnits="userSpaceOnUse"
    color-interpolation-filters="sRGB"
  >
    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
    <feBlend
      mode="normal"
      in="SourceGraphic"
      in2="BackgroundImageFix"
      result="shape"
    ></feBlend>
    <feGaussianBlur
      stdDeviation="10"
      result="effect1_foregroundBlur_557_14053"
    ></feGaussianBlur>
  </filter>
</defs>
</svg>
`,
    Ot = Go;
  var Ct = {
      animation: 'none',
      'animation-delay': '0',
      'animation-direction': 'normal',
      'animation-duration': '0',
      'animation-fill-mode': 'none',
      'animation-iteration-count': '1',
      'animation-name': 'none',
      'animation-play-state': 'running',
      'animation-timing-function': 'ease',
      'backface-visibility': 'visible',
      background: '0',
      'background-attachment': 'scroll',
      'background-clip': 'border-box',
      'background-color': 'transparent',
      'background-image': 'none',
      'background-origin': 'padding-box',
      'background-position': '0 0',
      'background-position-x': '0',
      'background-position-y': '0',
      'background-repeat': 'repeat',
      'background-size': 'auto auto',
      border: '0',
      'border-style': 'none',
      'border-width': 'medium',
      'border-color': 'inherit',
      'border-bottom': '0',
      'border-bottom-color': 'inherit',
      'border-bottom-left-radius': '0',
      'border-bottom-right-radius': '0',
      'border-bottom-style': 'none',
      'border-bottom-width': 'medium',
      'border-collapse': 'separate',
      'border-image': 'none',
      'border-left': '0',
      'border-left-color': 'inherit',
      'border-left-style': 'none',
      'border-left-width': 'medium',
      'border-radius': '0',
      'border-right': '0',
      'border-right-color': 'inherit',
      'border-right-style': 'none',
      'border-right-width': 'medium',
      'border-spacing': '0',
      'border-top': '0',
      'border-top-color': 'inherit',
      'border-top-left-radius': '0',
      'border-top-right-radius': '0',
      'border-top-style': 'none',
      'border-top-width': 'medium',
      bottom: 'auto',
      'box-shadow': 'none',
      'box-sizing': 'content-box',
      'caption-side': 'top',
      clear: 'none',
      clip: 'auto',
      color: 'inherit',
      columns: 'auto',
      'column-count': 'auto',
      'column-fill': 'balance',
      'column-gap': 'normal',
      'column-rule': 'medium none currentColor',
      'column-rule-color': 'currentColor',
      'column-rule-style': 'none',
      'column-rule-width': 'none',
      'column-span': '1',
      'column-width': 'auto',
      content: 'normal',
      'counter-increment': 'none',
      'counter-reset': 'none',
      cursor: 'auto',
      direction: 'ltr',
      display: 'inline',
      'empty-cells': 'show',
      float: 'none',
      font: 'normal',
      'font-family': 'inherit',
      'font-size': 'medium',
      'font-style': 'normal',
      'font-variant': 'normal',
      'font-weight': 'normal',
      height: 'auto',
      hyphens: 'none',
      left: 'auto',
      'letter-spacing': 'normal',
      'line-height': 'normal',
      'list-style': 'none',
      'list-style-image': 'none',
      'list-style-position': 'outside',
      'list-style-type': 'disc',
      margin: '0',
      'margin-bottom': '0',
      'margin-left': '0',
      'margin-right': '0',
      'margin-top': '0',
      'max-height': 'none',
      'max-width': 'none',
      'min-height': '0',
      'min-width': '0',
      opacity: '1',
      orphans: '0',
      outline: '0',
      'outline-color': 'invert',
      'outline-style': 'none',
      'outline-width': 'medium',
      overflow: 'visible',
      'overflow-x': 'visible',
      'overflow-y': 'visible',
      padding: '0',
      'padding-bottom': '0',
      'padding-left': '0',
      'padding-right': '0',
      'padding-top': '0',
      'page-break-after': 'auto',
      'page-break-before': 'auto',
      'page-break-inside': 'auto',
      perspective: 'none',
      'perspective-origin': '50% 50%',
      position: 'static',
      right: 'auto',
      'tab-size': '8',
      'table-layout': 'auto',
      'text-align': 'inherit',
      'text-align-last': 'auto',
      'text-decoration': 'none',
      'text-decoration-color': 'inherit',
      'text-decoration-line': 'none',
      'text-decoration-style': 'solid',
      'text-indent': '0',
      'text-shadow': 'none',
      'text-transform': 'none',
      top: 'auto',
      transform: 'none',
      'transform-style': 'flat',
      transition: 'none',
      'transition-delay': '0s',
      'transition-duration': '0s',
      'transition-property': 'none',
      'transition-timing-function': 'ease',
      'unicode-bidi': 'normal',
      'vertical-align': 'baseline',
      visibility: 'visible',
      'white-space': 'normal',
      widows: '0',
      width: 'auto',
      'word-spacing': 'normal',
      'z-index': 'auto',
    },
    Vo = 600;
  var Ut = (e, t = [/^https?:\/\/.*\.roomvo\.com$/, /^https?:\/\/.*\.leaptools\.com$/]) => {
      let o = (...i) => (t.some((a) => a.test(i[0].origin)) ? e(...i) : null),
        r = window.addEventListener ? 'addEventListener' : 'attachEvent',
        n = window[r],
        s = r == 'attachEvent' ? 'onmessage' : 'message';
      n(s, o, !1);
    },
    gt = () => {
      try {
        let e = document.createElement('canvas');
        if ((e.getContext('webgl') || e.getContext('experimental-webgl')) == null) throw 'nowebgl';
      } catch {
        return !1;
      }
      return !0;
    };
  var k = (e, t, o) => {
    St(e, t, o);
  };
  var Ho = function (e, t) {
      if (!e) return !1;
      for (let o = 0; o < t.length; ++o) if (!e.querySelector(t[o])) return !1;
      return !0;
    },
    St = function (e, t, o) {
      Ho(e, t) ? o() : setTimeout(St, 60, e, t, o);
    };
  function oe(e, t, o, r = !1, n = 30) {
    if (!e) return;
    let s = Array.from(e.querySelectorAll(t));
    if (s.length > 0 && (o(s) === !0 || r)) return;
    let i = new Set(),
      a = new MutationObserver((p) => {
        for (let m of p)
          for (let E of m.addedNodes) {
            E.matches?.(t) && i.add(E);
            let u = E.querySelectorAll?.(t);
            u?.length && u.forEach((_) => i.add(_));
          }
        i.size > 0 && l();
      }),
      c = () => {
        let p = Array.from(i);
        (o(p) || r) && a.disconnect(), i.clear();
      },
      l = n === 0 ? c : L(c, n, !1);
    a.observe(e, { childList: !0, subtree: !0 });
  }
  var Wo = function () {
      let e = () => Array.prototype.slice.call(document.styleSheets).every(t),
        t = (o) => !o.roomvo;
      if (e()) {
        let o = document.createElement('style');
        o.appendChild(document.createTextNode('')), document.head.appendChild(o);
        let r = o.sheet;
        return (r.roomvo = !0), r;
      }
    },
    $o = function () {
      let e = Wo();
      return e || [...document.styleSheets].find((t) => t.roomvo);
    },
    be = (e, t) => {
      t || (t = $o());
      for (let o of Ne(e)) t.insertRule(o, t.cssRules.length);
      return t;
    },
    Ne = (e) => {
      let t = [];
      for (let o = 0; o < e.length; o++) {
        let r = 1,
          n = e[o],
          s = n[0],
          i = '';
        Array.isArray(n[1][0]) && ((n = n[1]), (r = 0));
        for (let a = n.length; r < a; r++) {
          let c = n[r];
          i += `${c[0]}: ${c[1]}${c[2] ? ' !important' : ''};
`;
        }
        t.push(`${s}{${i}}`);
      }
      return t;
    },
    re = (e) => {
      Object.keys(Ct).forEach((t) => {
        e.style.setProperty(t, Ct[t], 'important');
      });
    };
  var It = (e, t) => {
      if (typeof t != 'function' || !e || typeof e != 'object') throw new Error('Invalid Arguments');
      document.querySelector('meta[name="viewport"][content*="device-width"][content*="initial-scale=1"]') ||
        document.head.insertAdjacentHTML(
          'beforeend',
          '<meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1" />'
        ),
        t(e),
        e?.isListenedTo !== !0 &&
          ((e.isListenedTo = !0), 'addEventListener' in e ? e.addEventListener('change', t) : e.addListener(t));
    },
    zo = (e) => {
      let t = e.parentElement;
      for (; t && t !== document.body; )
        (t.dataset.originalTransform = getComputedStyle(t).transform),
          (t.style.transform = 'none'),
          (t = t.parentElement);
    },
    Ko = (e) => {
      let t = e.parentElement;
      for (; t; )
        (t.style.transform = t.dataset.originalTransform || ''),
          delete t.dataset.originalTransform,
          (t = t.parentElement);
    };
  var qo = (e) => {
      let t = e.parentElement;
      for (; t; )
        (t.dataset.originalZIndex = getComputedStyle(t).zIndex), (t.style.zIndex = '2147483647'), (t = t.parentElement);
    },
    jo = (e) => {
      let t = e.parentElement;
      for (; t; )
        (t.style.zIndex = t.dataset.originalZIndex || ''), delete t.dataset.originalZIndex, (t = t.parentElement);
    },
    ve = class {
      constructor() {
        (this.transitionProperty = 'all'),
          (this.transitionTimeInMs = Vo),
          (this.transitionTimingFunction = 'cubic-bezier(0,1,.25,1)'),
          (this.isTransitioning = !1),
          (this.isFullScreen = !1),
          (this.location = { width: 0, height: 0, left: 0, top: 0, scrollY: 0, scrollX: 0 });
      }
      get transition() {
        return [this.transitionProperty, this.transitionTimeInMs / 1e3 + 's', this.transitionTimingFunction].join(' ');
      }
    },
    we = new WeakMap(),
    At = (e) => (we.has(e) || we.set(e, new ve()), we.get(e)),
    yt = (e) => {
      let t = At(e);
      if (t.isTransitioning || t.isFullScreen) return;
      t.isTransitioning = !0;
      let [o, r] = [e.scrollWidth, e.scrollHeight];
      [e.style.width, e.style.height] = [o + 'px', r + 'px'];
      let { left: n, top: s } = e.getBoundingClientRect();
      e.style.setProperty('left', n + 'px', 'important'),
        e.style.setProperty('top', s + 'px', 'important'),
        e.style.setProperty('z-index', '2147483647', 'important'),
        (t.contentRect = { scrollY: window.scrollY, scrollX: window.scrollX, width: o, height: r, left: n, top: s }),
        e.style.setProperty('position', 'fixed', 'important'),
        zo(e),
        qo(e),
        window.requestAnimationFrame(() => {
          e.style.setProperty('transition', t.transition, 'important'),
            e.style.setProperty('left', '0px', 'important'),
            e.style.setProperty('top', '0px', 'important'),
            e.style.setProperty('width', '100%', 'important'),
            e.style.setProperty('height', '100%', 'important'),
            (t.isFullScreen = !0),
            (t.isTransitioning = !1);
        });
    },
    Lt = (e) => {
      let t = At(e);
      if (t.isTransitioning || !t.isFullScreen) return;
      t.isTransitioning = !0;
      let { width: o, height: r, left: n, top: s, scrollY: i, scrollX: a } = t.contentRect;
      window.requestAnimationFrame(() => {
        let c = a - window.scrollX;
        e.style.setProperty('left', n + c + 'px', 'important');
        let l = i - window.scrollY;
        e.style.setProperty('top', s + l + 'px', 'important'),
          e.style.setProperty('width', o + 'px', 'important'),
          e.style.setProperty('height', r + 'px', 'important');
      }),
        setTimeout(() => {
          e.style.setProperty('width', '100%', 'important'),
            e.style.setProperty('height', '100%', 'important'),
            e.style.setProperty('position', 'unset', 'important'),
            e.style.setProperty('transition', 'unset', 'important'),
            Ko(e),
            jo(e),
            (t.isFullScreen = !1),
            (t.isTransitioning = !1);
        }, t.transitionTimeInMs);
    },
    Zo = (e) => {
      let { display: t, visibility: o, opacity: r } = getComputedStyle(e);
      return t !== 'none' && o !== 'hidden' && o !== 'collapse' && r !== '0' && r !== 0;
    },
    Xo = (e, t) => {
      let o;
      return (
        t
          ? (o = e.nodeName === 'DETAILS' && t.nodeName !== 'SUMMARY' ? e.hasAttribute('open') : !0)
          : (o = e.nodeName === 'DETAILS' ? e.hasAttribute('open') : !0),
        !e.hasAttribute('hidden') && o
      );
    },
    xt = (e) => {
      let t = 0,
        o = 0,
        r = 0,
        n = 0;
      if (e === window) (o = window.innerWidth), (r = window.innerHeight);
      else if (e === document) (o = document.documentElement.clientWidth), (r = document.documentElement.clientHeight);
      else if (e instanceof HTMLElement) {
        let s = e.getBoundingClientRect();
        (t = s.top), (o = s.right), (r = s.bottom), (n = s.left);
      }
      return { top: t, right: o, bottom: r, left: n };
    },
    te = ({
      elementTop: e,
      elementRight: t,
      elementBottom: o,
      elementLeft: r,
      containerTop: n,
      containerRight: s,
      containerBottom: i,
      containerLeft: a,
      minimumContainedPercentage: c = 1,
    }) => {
      if (o - e <= 0 || t - r <= 0 || e >= i || o <= n || r >= s || t <= a) return !1;
      let l = Math.max(e, n),
        p = Math.min(o, i),
        m = Math.round(((p - l) * 100) / (o - e)) / 100,
        E = Math.max(r, a),
        u = Math.min(t, s),
        _ = Math.round(((u - E) * 100) / (t - r)) / 100;
      return m >= c && _ >= c;
    },
    Jo = (e, t = 1) => {
      let { top: o, right: r, bottom: n, left: s } = e.getBoundingClientRect(),
        i = e.parentElement;
      for (; i && i !== document.body; ) {
        let { overflowX: a, overflowY: c } = getComputedStyle(i),
          l = !0,
          { top: p, right: m, bottom: E, left: u } = xt(i);
        if (
          (a !== 'visible' && c !== 'visible'
            ? (l = te({
                elementTop: o,
                elementRight: r,
                elementBottom: n,
                elementLeft: s,
                containerTop: p,
                containerRight: m,
                containerBottom: E,
                containerLeft: u,
                minimumContainedPercentage: t,
              }))
            : a !== 'visible' && c === 'visible'
            ? (l = te({
                elementTop: o,
                elementRight: r,
                elementBottom: n,
                elementLeft: s,
                containerTop: o,
                containerRight: m,
                containerBottom: n,
                containerLeft: u,
                minimumContainedPercentage: t,
              }))
            : a === 'visible' &&
              c !== 'visible' &&
              (l = te({
                elementTop: o,
                elementRight: r,
                elementBottom: n,
                elementLeft: s,
                containerTop: p,
                containerRight: r,
                containerBottom: E,
                containerLeft: s,
                minimumContainedPercentage: t,
              })),
          !l)
        )
          return !1;
        i = i.parentElement;
      }
      return !0;
    },
    Dt = (e, t) => Zo(e) && Xo(e, t) && (!e.parentElement || Dt(e.parentElement, e)),
    Be = (e, t = 1) => {
      let { top: o, right: r, bottom: n, left: s } = e.getBoundingClientRect(),
        { top: i, right: a, bottom: c, left: l } = xt(window);
      return (
        te({
          elementTop: o,
          elementRight: r,
          elementBottom: n,
          elementLeft: s,
          containerTop: i,
          containerRight: a,
          containerBottom: c,
          containerLeft: l,
          minimumContainedPercentage: t,
        }) &&
        Dt(e) &&
        Jo(e, t)
      );
    };
  var wt = (e) => {
      let t = { alpha: 255 };
      if (((e = e.replace('#', '')), e.length === 3)) {
        let o = (r) => parseInt(r + r, 16);
        (t.red = parseInt(o(e.slice(0, 1)))),
          (t.green = parseInt(o(e.slice(1, 2)))),
          (t.blue = parseInt(o(e.slice(2, 3))));
      } else if (e.length === 6)
        (t.red = parseInt(e.slice(0, 2), 16)),
          (t.green = parseInt(e.slice(2, 4), 16)),
          (t.blue = parseInt(e.slice(4, 6), 16));
      else return;
      return t;
    },
    Qo = (e) => {
      let t = e.toString('16');
      return t.length === 1 ? '0' + t : t;
    };
  var vt = (e, t, o = 50) => (
      (e = wt(e)),
      (t = wt(t)),
      '#' + ['red', 'green', 'blue'].map((r) => Qo(Math.round(t[r] + (e[r] - t[r]) * (o / 100)))).join('')
    ),
    bt = (e, t) => vt('#FFFFFF', e, t),
    Nt = (e, t) => vt('#000000', e, t);
  var er = `
/***
 The new CSS reset - version 1.7.3 (last updated 7.8.2022)
 GitHub page: https://github.com/elad2412/the-new-css-reset
***/

/*
 Remove all the styles of the "User-Agent-Stylesheet", except for the 'display' property
 - The "symbol *" part is to solve Firefox SVG sprite bug
*/
*:where(:not(html, iframe, canvas, img, svg, video, audio):not(svg *, symbol *)) {
 all: unset;
 display: revert;
}

/* Preferred box-sizing value */
*,
*::before,
*::after {
 box-sizing: border-box;
}

/* Reapply the pointer cursor for anchor tags */
a, button {
 cursor: revert;
}

/* Remove list styles (bullets/numbers) */
ol, ul, menu {
 list-style: none;
}

/* For images to not be able to exceed their container */
img {
 max-width: 100%;
}

/* removes spacing between cells in tables */
table {
 border-collapse: collapse;
}

/* Safari - solving issue when using user-select:none on the <body> text input doesn't working */
input, textarea {
 -webkit-user-select: auto;
}

/* revert the 'white-space' property for textarea elements on Safari */
textarea {
 white-space: revert;
}

/* minimum style to allow to style meter element */
meter {
 -webkit-appearance: revert;
 appearance: revert;
}

/* reset default text opacity of input placeholder */
::placeholder {
 color: unset;
}

/* fix the feature of 'hidden' attribute.
display:revert; revert to element instead of attribute */
:where([hidden]) {
 display: none;
}

/* revert for bug in Chromium browsers
- fix for the content editable attribute will work properly.
- webkit-user-select: auto; added for Safari in case of using user-select:none on wrapper element*/
:where([contenteditable]:not([contenteditable="false"])) {
 -moz-user-modify: read-write;
 -webkit-user-modify: read-write;
 overflow-wrap: break-word;
 -webkit-line-break: after-white-space;
 -webkit-user-select: auto;
}

/* apply back the draggable feature - exist only in Chromium and Safari */
:where([draggable="true"]) {
 -webkit-user-drag: element;
}
`,
    Bt = er;
  var tr = 1,
    or = 2,
    rr = 3,
    nr = 4,
    sr = 5,
    ir = 7,
    ar = 8,
    cr = 9,
    lr = 10,
    dr = 11,
    pr = 12,
    ur = 13,
    _r = 14,
    mr = 15,
    Tr = 16,
    Pr = 17,
    Er = 18,
    hr = 19,
    Rr = 20,
    fr = 21,
    Or = 22,
    Cr = 23,
    Ur = 24,
    gr = 25,
    Sr = 26,
    Ir = 27,
    Ar = 28,
    yr = 29,
    Lr = 30,
    xr = 31,
    Dr = 32,
    wr = 33,
    vr = 34,
    br = 35,
    Nr = 36,
    Br = 37,
    Yr = 38,
    Mr = 39,
    Fr = 40,
    kr = 41,
    Gr = 42,
    Vr = 43,
    Hr = 44,
    Wr = 1e3,
    $r = 1001,
    zr = 1002,
    Kr = 1003,
    qr = 1004,
    jr = 1005,
    Zr = 1006,
    Xr = 1007,
    Jr = 1008,
    Qr = 1009,
    en = 1010,
    tn = 1011,
    on = 1012,
    rn = 1013,
    nn = 1014,
    sn = 1015,
    an = 1016,
    cn = 1017,
    ln = 1018,
    dn = 1019,
    pn = 1020,
    un = 1021,
    _n = 1022,
    mn = 1023,
    Tn = 1024,
    Pn = 1025,
    En = 1026,
    hn = 1027,
    Rn = 1028,
    fn = 1029,
    On = 1030,
    Cn = 1031,
    Un = 1032,
    gn = 1033,
    Sn = 1034,
    In = 1035,
    An = 1036,
    yn = 1037,
    Ln = 1038,
    xn = 1039,
    Dn = 1040,
    wn = 1041,
    vn = 1042,
    bn = 1043,
    Nn = 1044,
    Bn = 1045,
    Yn = 1046,
    Mn = 1047,
    Fn = 1048,
    kn = 1049,
    Gn = 1050,
    Vn = 1051,
    Hn = 1052,
    Wn = 1053,
    $n = 1054,
    zn = 1055,
    Kn = 1056,
    qn = 1057,
    jn = 1058,
    Zn = 1059,
    Xn = 1060,
    Jn = 1061,
    Qn = 1062,
    es = 1063,
    ts = 1064,
    os = 1065,
    rs = 1066,
    ns = 1067,
    ss = 1068,
    is = 1069,
    as = 1070,
    cs = 1071,
    ls = 1072,
    ds = 1073,
    ps = 1074,
    us = 1075,
    _s = 1076,
    ms = 1077,
    Ts = 1078,
    Ps = 1079,
    Es = 1080,
    hs = 1081,
    Rs = 1082,
    fs = 1083,
    Os = 1084,
    Cs = 1086,
    Us = 1087,
    gs = 1088,
    Ss = 1089,
    Is = 1090,
    As = 1091,
    ys = 1092,
    Ls = 1093,
    xs = 1094,
    Ds = 1095,
    ws = 1096,
    vs = 1097,
    bs = 1098,
    Ns = 1099,
    Bs = 1100,
    Ys = 1101,
    Ms = 1102,
    Fs = 1103,
    ks = 1104,
    Gs = 1105,
    Vs = 1106,
    Hs = 1107,
    Ws = 1108,
    $s = 1109,
    zs = 1110,
    Ks = 1111,
    qs = 1112,
    js = 1113,
    Zs = 1114,
    Xs = 1115,
    Js = 1116,
    Qs = 1117,
    ei = 1118,
    ti = 1119,
    oi = 1120,
    ri = 1121,
    ni = 1123,
    si = 1124,
    ii = 1125,
    ai = 1126,
    ci = 1127,
    li = 1128,
    di = 1129,
    pi = 1131,
    ui = 1132,
    _i = 1133,
    mi = 1134,
    Ti = 1135,
    Pi = 1136,
    Ei = 1137,
    hi = 1138,
    Ri = 1139,
    fi = 1140;
  var Oi = 0,
    Ci = 1,
    Ui = 2,
    gi = 3,
    pc = { [Oi]: 'shade.unknown', [Ci]: 'shade.light', [Ui]: 'shade.medium', [gi]: 'shade.dark' },
    Si = 0,
    Ii = 1,
    Ai = 2,
    yi = 3,
    Li = 4,
    xi = 5,
    Di = 6,
    wi = 7,
    vi = 8,
    bi = 9,
    Ni = 10,
    Bi = 11,
    uc = {
      [Si]: 'color.unknown',
      [Ii]: 'color.beige',
      [Ai]: 'color.black',
      [yi]: 'color.blue',
      [Li]: 'color.brown',
      [xi]: 'color.gray',
      [Di]: 'color.green',
      [wi]: 'color.orange',
      [vi]: 'color.purple',
      [bi]: 'color.red',
      [Ni]: 'color.white',
      [Bi]: 'color.yellow',
    };
  var Yt = {
    1: 'Floors',
    2: 'Rugs',
    3: 'Furniture',
    4: 'Countertops',
    5: 'Walls',
    6: 'Cabinets',
    7: 'Wall Decors',
    8: 'Ceilings',
    9: 'Doors',
    10: 'Trims',
    11: 'Furniture Coatings',
    12: 'Roofs',
    13: 'Radiators',
    14: 'Storage',
    15: 'Lighting',
    16: 'Appliances',
    17: 'Fenestrations',
    18: 'Window Treatments',
    19: 'Decor',
    20: 'Staircases',
    21: 'Plumbing Fixtures',
    22: 'Fireplaces',
    23: 'Outdoor Structures',
    24: 'Landscaping',
  };
  var Mt = {
    [hr]: 'Area Rugs',
    [Pr]: 'Boards and Panels',
    [Er]: 'Brick and Stone',
    [_r]: 'Butcher Block',
    [ir]: 'product_subtype.carpet_tile',
    [pr]: 'Concrete',
    [cr]: 'Engineered Stone',
    [tr]: 'product_subtype.hardwood',
    [dr]: 'product_subtype.laminate',
    [nr]: 'product_subtype.luxury_vinyl',
    [fr]: 'Mats',
    [ar]: 'Natural Stone',
    [Or]: 'Other',
    [Rr]: 'Outdoor Rugs',
    [mr]: 'Paint',
    [sr]: 'Carpet',
    [lr]: 'product_subtype.solid_surface',
    [ur]: 'Stainless Steel',
    [or]: 'product_subtype.tile',
    [rr]: 'product_subtype.vinyl',
    [Tr]: 'Wallpaper',
    [Cr]: 'Flat Panel Cabinet',
    [Ur]: 'Shaker Cabinet',
    [gr]: 'Inset Cabinet',
    [Sr]: 'Thermofoil Cabinet',
    [Ir]: 'Glass Cabinet',
    [Ar]: 'Wall Art',
    [yr]: 'Murals and Decals',
    [Lr]: 'Wall Mirrors',
    [xr]: 'Posters and Prints',
    [Dr]: 'Signs',
    [wr]: 'Wall Clocks',
    [vr]: 'Wall Shelves',
    [br]: 'Wall Sconces',
    [Nr]: 'Stain',
    [Br]: 'Paver',
    [Yr]: 'Decking',
    [Mr]: 'Resin',
    [Fr]: 'Outdoor Carpet',
    [kr]: 'Gravel',
    [Gr]: 'Artificial Grass',
    [Vr]: 'Rubber',
    [Hr]: 'Tarmac',
    [Wr]: 'Tables',
    [$r]: 'Changing Tables',
    [zr]: 'Coffee Tables',
    [Kr]: 'Console Tables',
    [qr]: 'Desks',
    [jr]: 'Dining Tables',
    [Zr]: 'Meeting Tables',
    [Xr]: 'Side Tables',
    [Jr]: 'Seating',
    [Qr]: 'Beds',
    [en]: 'Cribs',
    [tn]: 'Benches',
    [on]: 'Chairs',
    [rn]: 'Armchairs',
    [nn]: 'Desk Chairs',
    [sn]: 'Dining Chairs',
    [an]: 'Ottomans',
    [cn]: 'Sofas',
    [ln]: 'Stools',
    [dn]: 'Storage',
    [pn]: 'Cabinets',
    [un]: 'Corner Cabinets',
    [_n]: 'Dressers',
    [mn]: 'Island Cabinets',
    [Tn]: 'Kitchen Cabinets',
    [Pn]: 'Nightstands',
    [En]: 'Sideboards',
    [hn]: 'Vanities',
    [Rn]: 'Wall Cabinets',
    [fn]: 'Shelves',
    [On]: 'Shoe Storage',
    [Cn]: 'TV Stands',
    [Un]: 'Wardrobes',
    [gn]: 'Lighting',
    [Sn]: 'Ceiling Fans',
    [In]: 'Lamps',
    [An]: 'Ceiling Lamps',
    [yn]: 'Floor Lamps',
    [Ln]: 'Table Lamps',
    [xn]: 'Wall Lamps',
    [Dn]: 'Appliances',
    [wn]: 'Dishwashers',
    [vn]: 'Dryers',
    [bn]: 'Microwaves',
    [Nn]: 'Ranges',
    [Bn]: 'Range Hoods',
    [Yn]: 'Refrigerators',
    [Mn]: 'Washing Machines',
    [Fn]: 'Fenestrations',
    [kn]: 'Doors',
    [Gn]: 'Windows',
    [Vn]: 'Decors',
    [Hn]: 'Mirrors',
    [Wn]: 'Furniture',
    [$n]: 'Foot Rests',
    [zn]: 'Poufs',
    [Kn]: 'Foot Stools',
    [qn]: 'Futons',
    [jn]: 'Love Seats',
    [Zn]: 'Sectionals',
    [Xn]: 'Daybeds',
    [Jn]: 'Room Dividers',
    [Qn]: 'Medicine Cabinets',
    [es]: 'File Cabinets',
    [ts]: 'Standing Shelves',
    [os]: 'Shoe Racks',
    [rs]: 'Kitchen Carts',
    [ns]: 'Chandeliers',
    [ss]: 'Recessed Lighting',
    [is]: 'Freezers',
    [as]: 'Beverage Chillers',
    [cs]: 'Cooking Appliances',
    [ls]: 'Cooktops',
    [ds]: 'Wall Ovens',
    [ps]: 'Grills',
    [us]: 'Ice Makers',
    [_s]: 'Small Appliances',
    [ms]: 'Garage Doors',
    [Ts]: 'Skylights',
    [Ps]: 'Window Treatments',
    [Es]: 'Blinds',
    [hs]: 'Shades',
    [Rs]: 'Shutters',
    [fs]: 'Curtains',
    [Os]: 'Wall Decor',
    [Cs]: 'Floor Mirrors',
    [Us]: 'Staircases',
    [gs]: 'Roofing',
    [Ss]: 'Ceiling Coverings',
    [Is]: 'Ceiling Tiles',
    [As]: 'Ceiling Planks',
    [ys]: 'Trims',
    [Ls]: 'Baseboards',
    [xs]: 'Mouldings',
    [Ds]: 'Casings',
    [ws]: 'Plumbing Fixtures',
    [vs]: 'Tubs',
    [bs]: 'Showers',
    [Ns]: 'Toilets',
    [Bs]: 'Bidets',
    [Ys]: 'Faucets',
    [Ms]: 'Shower Heads',
    [Fs]: 'Shower Curtains',
    [Ri]: 'Shower Stalls',
    [ks]: 'Sinks',
    [Gs]: 'Sink Basins',
    [hi]: 'Pedestal Sinks',
    [Vs]: 'Fireplaces',
    [Hs]: 'Outdoor Structures',
    [Ws]: 'Tents',
    [$s]: 'Fences',
    [zs]: 'Greenhouses',
    [Ks]: 'Pools',
    [qs]: 'Gazebos',
    [fi]: 'Hot Tubs',
    [js]: 'Landscaping',
    [Zs]: 'Gardens',
    [Xs]: 'Trees',
    [Js]: 'Bushes',
    [Qs]: 'Hedges',
    [ei]: 'Chaise Lounges',
    [ti]: 'Lounge Chairs',
    [oi]: 'Bunk Beds',
    [ri]: 'Loft Beds',
    [ni]: 'Sofa Beds',
    [si]: 'Pendant Lights',
    [ii]: 'Floors',
    [ai]: 'Countertops',
    [ci]: 'Walls',
    [li]: 'Rugs',
    [di]: 'Furniture Coatings',
    [pi]: 'Radiators',
    [ui]: 'Gutters',
    [_i]: 'Fascia',
    [mi]: 'Track Lights',
    [Ti]: 'Flush Mount Lights',
    [Pi]: 'Sheds',
    [Ei]: 'Storage Chests',
  };
  var Yi = 0,
    Mi = 1,
    Fi = 2,
    ki = 3,
    _c = { [Yi]: 'Warm White', [Mi]: 'Soft White', [Fi]: 'Daylight', [ki]: 'Crystal White' },
    z = 'en-us';
  var ne = (e, t, o = !1) => {
      let r = e.getLocale();
      if (r in e._localizedStrings && t in e._localizedStrings[r]) return e._localizedStrings[r][t];
      let n = Object.keys(e._localizedStrings),
        s = (a) => a.split('-')[0],
        i = n.map(s).indexOf(s(r));
      if (i !== -1) {
        let a = e._localizedStrings[n[i]]?.[t];
        if (a) return a;
      }
      return o ? '' : t in e._localizedStrings[z] ? e._localizedStrings[z][t] : t;
    },
    se = (e) => {
      let t = Object.assign({}, Tt),
        o = e.getLocalizedStringOverrides();
      for (let [r, n] of Object.entries(o)) r === z ? Object.assign(t[z], n) : (t[r] = n);
      return (e._localizedStrings = t), null;
    };
  var ie = class extends HTMLElement {
      constructor() {
        super(),
          this.attachShadow({ mode: 'open' }),
          (this.cssRules = Bt),
          (this.shouldHide = void 0),
          (this.styleNode = void 0),
          (this.contentNode = void 0),
          (this.logoNode = void 0),
          (this.src = void 0),
          (this.textNode = void 0),
          (this.text = void 0),
          (this.color = void 0);
      }
      applyCssRules() {
        this.styleNode || (this.styleNode = document.createElement('style')),
          (this.styleNode.textContent = this.cssRules),
          this.shadowRoot.appendChild(this.styleNode);
      }
      addCssRules(t) {
        this.cssRules += Ne(t).join(`
`);
      }
      connectedCallback() {
        this.isConnected &&
          ((this.color = this.getAttribute('color')),
          (this.src = this.getAttribute('src')),
          (this.text = this.getAttribute('text')),
          (this.shouldHide = this.getAttribute('hide')),
          this.create(),
          this.applyCssRules(),
          this.updateDisplay(!0));
      }
      static get observedAttributes() {
        return ['color', 'hide', 'src', 'text'];
      }
      attributeChangedCallback(t, o, r) {
        if (this.isConnected)
          switch (t) {
            case 'color':
              (this.color = r), this.updateLoaderColor();
              break;
            case 'hide':
              (this.shouldHide = r), this.updateDisplay();
              break;
            case 'src':
              (this.src = r), this.updateOrInsertLogo();
              break;
            case 'text':
              (this.text = r), this.updateOrInsertText();
              break;
          }
      }
      updateDisplay(t) {
        let o = this.shadowRoot?.firstChild;
        if (o)
          if (this.shouldHide !== null) {
            if (!t) {
              let r = (n) => {
                n.target.classList.contains('roomvo-launch-sequence--hide') &&
                  ((o.style.display = 'none'), this.shadowRoot.removeEventListener('transitionend', r));
              };
              this.shadowRoot.addEventListener('transitionend', r);
            }
            o.classList.add('roomvo-launch-sequence--hide');
          } else
            (o.style.display = 'grid'),
              window.requestAnimationFrame(() => o.classList.remove('roomvo-launch-sequence--hide'));
      }
      create() {
        let t = this.createModal();
        t.append(this.createContent()), t.append(this.createRoomvoBranding());
        let o = this.createContainer();
        return o.append(t), this.shadowRoot.append(o), o;
      }
      createModal() {
        let t = document.createElement('div');
        t.classList.add('roomvo-launch-sequence__modal');
        let o = [
          [
            `.${t.className}`,
            ['width', '80%'],
            ['max-width', '640px'],
            ['border-radius', '16px'],
            ['background-color', 'white'],
            ['box-shadow', '0px 40px 40px rgba(57, 59, 68, 0.20)'],
            ['opacity', '1'],
            ['transform', 'translateY(0%)'],
            ['transition', 'all 0.25s cubic-bezier(0,0.25,0.29,1) 1s'],
            ['transition-delay', '0.25s'],
          ],
          [
            `.roomvo-launch-sequence--hide .${t.className}`,
            ['transform', 'translateY(5%)'],
            ['opacity', '0'],
            ['transition-delay', '0s'],
          ],
        ];
        return this.addCssRules(o), t;
      }
      createContent() {
        (this.contentNode = document.createElement('div')),
          this.contentNode.classList.add('roomvo-launch-sequence__content');
        let t = [
          [
            `.${this.contentNode.className}`,
            [
              ['display', 'grid'],
              ['place-items', 'center'],
              ['gap', '32px'],
              ['grid-gap', '32px'],
              ['max-width', '80%'],
              ['margin-left', 'auto'],
              ['margin-right', 'auto'],
            ],
          ],
        ];
        this.addCssRules(t);
        let o = window.matchMedia('(min-width: 600px)');
        It(o, (s) => {
          this.contentNode.style.setProperty('padding', s.matches ? '12.5vh 0' : '7.5vh 0', 'important');
        }),
          (this.logoNode = this.createLogo()),
          this.logoNode && this.contentNode.append(this.logoNode),
          (this.textNode = this.createText()),
          this.textNode && this.contentNode.append(this.textNode);
        let n = this.createLoader();
        return n && this.contentNode.append(n), this.contentNode;
      }
      createLogo() {
        if (!this.src) return null;
        let t = document.createElement('div');
        t.style.setProperty('max-width', '70%');
        let o = document.createElement('img');
        return (
          (o.src = this.src),
          (o.alt = ''),
          o.style.setProperty('opacity', '0'),
          (o.onload = () => (o.style.opacity = '1')),
          o.style.setProperty('transition', 'opacity 0.2s ease-in'),
          o.style.setProperty('object-fit', 'contain'),
          o.style.setProperty('height', '175px'),
          o.style.setProperty('width', '100%'),
          t.append(o),
          t
        );
      }
      updateOrInsertLogo() {
        this.logoNode && this.src
          ? (this.logoNode.firstChild.src = this.src)
          : this.logoNode
          ? (this.logoNode.remove(), (this.logoNode = null))
          : this.src && ((this.logoNode = this.createLogo()), this.contentNode.prepend(this.logoNode));
      }
      createText() {
        if (!this.text) return null;
        let t = document.createElement('p');
        return (
          t.append(this.text),
          t.style.setProperty('font', 'normal normal normal 16px/24px Sans-Serif'),
          t.style.setProperty('color', '#373C40'),
          t.style.setProperty('text-align', 'center'),
          t.style.setProperty('margin', '0'),
          t
        );
      }
      updateOrInsertText() {
        this.textNode && this.text
          ? (this.textNode.innerText = this.text)
          : this.textNode
          ? (this.textNode.remove(), (this.textNode = null))
          : this.text &&
            ((this.textNode = this.createText()),
            this.logoNode
              ? this.logoNode.insertAdjacentElement('afterend', this.textNode)
              : this.contentNode.prepend(this.textNode));
      }
      createLoader() {
        let t = document.createElement('div');
        t.classList.add('roomvo-launch-sequence__loader-cubes');
        let o = [
          [
            `.${t.className}`,
            ['position', 'relative'],
            ['min-width', '96px'],
            ['min-height', '48px'],
            ['padding-top', '24px'],
          ],
        ];
        return (
          this.addCssRules(o),
          t.insertAdjacentHTML('afterbegin', Ot),
          this.colorLoader(),
          this.animateLoader(t.className),
          t
        );
      }
      colorLoader() {
        let t = this.color ?? '#818C98',
          o = Nt.bind(null, t),
          r = bt.bind(null, t),
          [n, s, i, a] = [r(10), o(10), o(42), o(30)],
          c = [
            ['path.cube__top', ['fill', n]],
            ['path.cube__left-side', ['fill', s]],
            ['path.cube__shadow', ['fill', i]],
            ['path.cube__right-side', ['fill', a]],
          ];
        this.addCssRules(c);
      }
      updateLoaderColor() {
        this.cssRules.replaceAll(/path\.cube.*?}/gs, ''), this.colorLoader(), this.applyCssRules();
      }
      animateLoader(t) {
        let o = [
          [`.${t}>.loader-cubes__cube`, ['position', 'absolute']],
          [
            ['loader-cubes__four', 'loader-cubes__one', 'loader-cubes__three', 'loader-cubes__two']
              .map((r) => `.${t}>.${r}`)
              .join(','),
            ['animation-duration', '.85s'],
            ['animation-iteration-count', 'infinite'],
            ['animation-timing-function', 'ease-in-out'],
          ],
          [`.${t}>.loader-cubes__one`, ['transform', 'translate(-36%,-16%)'], ['animation-name', 'loader-cubes__one']],
          [`.${t}>.loader-cubes__two`, ['transform', 'translate(-10%,0)'], ['animation-name', 'loader-cubes__two']],
          [
            `.${t}>.loader-cubes__three`,
            ['transform', 'translate(16%,-16%)'],
            ['animation-name', 'loader-cubes__three'],
          ],
          [`.${t}>.loader-cubes__four`, ['transform', 'translate(42%,0)'], ['animation-name', 'loader-cubes__four']],
        ];
        this.addCssRules(o),
          [
            `@keyframes loader-cubes__one {
                0% {
                  transform: translate(-36%, -16%);
                }
                50% {
                  transform: translate(-10%, -32%);
                }
                100% {
                  transform: translate(16%, -16%);
                }
            }
            `,
            `@keyframes loader-cubes__two {
                0%,
                50% {
                  transform: translate(-10%, 0);
                }
                100% {
                  transform: translate(-36%, -16%);
                }
              }
              `,
            `@keyframes loader-cubes__three {
                0%,
                50% {
                  transform: translate(16%, -16%);
                }
                100% {
                  transform: translate(42%, 0);
                }
              }
              `,
            `@keyframes loader-cubes__four {
                0% {
                  transform: translate(42%, 0);
                }
                50% {
                  transform: translate(16%, 16%);
                }
                100% {
                  transform: translate(-10%, 0);
                }
              }
              `,
          ].forEach((r) => (this.cssRules += r));
      }
      createRoomvoBranding() {
        let t = document.createElement('p');
        t.style.setProperty('font', 'normal normal normal 14px/20px Sans-Serif'),
          t.style.setProperty('text-align', 'center'),
          t.style.setProperty('color', '#818C98'),
          t.style.setProperty('margin-bottom', '4.8px'),
          (t.innerText = 'Powered by ');
        let o = document.createElement('strong');
        return (
          o.style.setProperty('font-weight', '500'),
          o.style.setProperty('color', '#FF3D00'),
          (o.innerText = 'roomvo'),
          t.append(o),
          t
        );
      }
      createContainer() {
        let t = document.createElement('div');
        t.classList.add('roomvo-launch-sequence__container');
        let o = [
          [
            `.${t.className}`,
            ['position', 'fixed'],
            ['top', '0'],
            ['left', '0'],
            ['backdrop-filter', 'blur(8px)'],
            ['height', '100%'],
            ['width', '100%'],
            ['background-color', 'rgba(255,255,255,0.7)'],
            ['z-index', '2147483647'],
            ['place-items', 'center'],
            ['display', 'grid'],
            ['opacity', '1'],
            ['transition', 'opacity 0.5s'],
            ['transition-delay', '0s'],
          ],
          [`.${t.className}.roomvo-launch-sequence--hide`, ['opacity', '0'], ['transition-delay', '1s']],
        ];
        return this.addCssRules(o), t;
      }
    },
    Ft = (e) => {
      let t = document.getElementById($) || Wi(e);
      t.hasAttribute('hide') && window.requestAnimationFrame(() => t.removeAttribute('hide')),
        t.dataset?.closingTimerId || (t.dataset.closingTimerId = setTimeout(Ye, e.launchSequenceTimeoutDuration, e)),
        (t.dataset.startTime = Date.now());
    },
    Gi = () => {
      let e = document.getElementById($);
      e &&
        (e.setAttribute('hide', ''),
        e.dataset?.closingTimerId !== 'null' &&
          (clearTimeout(e.dataset.closingTimerId), delete e.dataset.closingTimerId));
    },
    ae = (e) => {
      e.classList.contains('roomvo-popup--loading') &&
        (e.classList.remove('roomvo-popup--loading'),
        (e.ariaHidden = !1),
        window.requestAnimationFrame(() => {
          e.classList.add('roomvo-popup--show');
        }));
    },
    Ye = (e) => {
      let t = document.getElementById(f);
      t.addEventListener('transitionend', Gi, { once: !0 }), Hi(e) ? setTimeout(() => ae(t), Vi()) : ae(t);
    },
    Vi = (e = 1500) => {
      let t = Number(document.getElementById($).dataset?.startTime) || 0;
      return Math.max(t + e - Date.now(), 0);
    },
    Hi = (e, t = 1) => {
      let o = !O(e, 'check', { cookieName: ye }),
        r = new Date();
      r.setTime(r.getTime() + t * 60 * 60 * 1e3);
      let n = r.toUTCString();
      return O(e, 'write', { cookieName: ye, cookieValue: '', config: { cookieExpiration: n } }), o;
    },
    Wi = (e) => {
      window.customElements.get('launch-sequence') === void 0 &&
        window.customElements.define('launch-sequence', e.getLaunchSequenceClass());
      let t = document.createElement('launch-sequence');
      return (
        (t.id = $),
        t.setAttribute('src', e.vendorLogoUrl),
        t.setAttribute('text', $i(e)),
        t.setAttribute('color', e.launchSequenceLoaderBaseColor),
        t.setAttribute('hide', ''),
        document.body.append(t),
        t
      );
    },
    $i = (e) => (se(e), ne(e, 'Loading...', !0));
  var A = (e) =>
    ['number', 'string'].includes(typeof e)
      ? !isNaN(e) && Number.isInteger(parseFloat(e))
        ? e in X
          ? parseInt(e)
          : U
        : parseInt(Object.keys(X).find((o) => X[o] === e)) || U
      : U;
  var R = (e) => {
      try {
        if (!e || !(e instanceof Element)) return '[invalid element]';
        let t = [],
          o = e.tagName ? e.tagName.toLowerCase() : 'unknown';
        return (
          t.push(o),
          e.id?.trim() && t.push(`#${e.id.trim()}`),
          e.className &&
            typeof e.className == 'string' &&
            e.className.trim() &&
            t.push(`.${e.className.trim().replace(/\s+/g, '.')}`),
          t.join('') || '[empty element]'
        );
      } catch {
        return '[error getting element info]';
      }
    },
    ce = (e) => {
      if (!e) return '[no elements]';
      try {
        let t = Array.isArray(e) ? e : Array.from(e || []);
        return t.length ? t.map((o) => R(o)).join(', ') : '[empty list]';
      } catch {
        return '[error processing elements]';
      }
    };
  var zi = 50,
    Ki = 4e3,
    b = async (e, t, o) => {
      if (!t) return Promise.resolve();
      if (((e.queuedProductCodeRequests ??= {}), e.productCodeMap?.[t]))
        try {
          return e.productCodeMap[t].length > 0 && (await o?.()), Promise.resolve();
        } catch (r) {
          return Promise.reject(r);
        }
      return new Promise((r, n) => {
        (e.queuedProductCodeRequests[t] ??= []),
          e.queuedProductCodeRequests[t].push({ callback: o, resolve: r, reject: n }),
          (e.debouncedFetchProductCodeMappings ??= L(qi, zi, !1)),
          e.debouncedFetchProductCodeMappings(e);
      });
    },
    qi = async (e) => {
      let t = e.queuedProductCodeRequests || {};
      e.queuedProductCodeRequests = {};
      let o = Object.keys(t);
      if (o.length === 0) return;
      let r = 0,
        n = [];
      n[r] = [];
      for (let c of o) {
        let l = [...n[r], c];
        encodeURIComponent(B(l)).length > Ki ? (n[++r] = [c]) : n[r].push(c);
      }
      let s = `?vendor=${await e.getVendorId()}`,
        i = e._registeredModules.has(_t) ? '&has_designer_products=1' : '',
        a = e.shouldIncludeUpstreamProductMappings() ? '&include_upstream_product_mappings=1' : '';
      for (let c = 0; c <= r; ++c) {
        let l = '&product_code__in=' + encodeURIComponent(B(n[c])),
          p = e.serverUrl + '/services/product/product_mappings/' + s + l + i + a;
        try {
          let m = await fetch(p);
          if (!m.ok) throw new Error(`Network response was not ok. Status: ${m.status}`);
          let E = await m.json();
          for (let u of E) (e.productCodeMap[u.productCode] ??= []), e.productCodeMap[u.productCode].push(u);
          for (let u of n[c]) {
            e.productCodeMap[u] ??= [];
            let _ = e.productCodeMap[u].length > 0,
              T = t[u] || [];
            await Promise.allSettled(
              T.map(async (S) => {
                try {
                  _ && (await S.callback?.()), S.resolve?.();
                } catch (Y) {
                  S.reject?.(Y);
                }
              })
            );
          }
        } catch (m) {
          d(e, `Failed to fetch product mappings for product codes ${n[c]}: ${m}`);
          for (let E of n[c]) (t[E] || []).forEach((_) => _.reject?.(m));
        }
      }
    },
    G = (e, t, o) => {
      let r = e?.productCodeMap?.[t];
      if (!r?.length) return;
      let n = [],
        s = [];
      for (let i of r) i.product && (i.productType === o ? n.push(i.product) : s.push(i.product));
      return [...n, ...s].join(',');
    },
    le = (e, t, o, r) =>
      e.productCodeMap[o] === void 0
        ? (d(e, `ERROR: Unknown product code ${o} on ${R(t)}`), !1)
        : e.productCodeMap[o].length === 0
        ? (/\u200b/.test(o)
            ? d(
                e,
                `No product code mappings available for ${o.replace(
                  /\u200b/,
                  '\u200B'
                )}. Zero space character detected on ${R(t)}`
              )
            : d(e, `No product code mappings available for ${o} on ${R(t)}`),
          !1)
        : r
        ? e.productCodeMap[o].some((s) => s.productType === r)
          ? (d(e, `Product code mappings available for ${o} with product type ${r} on ${R(t)}`), !0)
          : (d(e, `No product code mappings available for ${o} with product type ${r} on ${R(t)}`), !1)
        : (d(e, `Product code mappings available for ${o} (no product type provided) on ${R(t)}`), !0);
  var de = { LEFT: 'left', RIGHT: 'right' },
    ji = (e = f) => {
      if (!document.getElementById(e)) {
        let t = document.createElement('iframe');
        re(t),
          t.style.setProperty('display', 'none', 'important'),
          t.style.setProperty('position', 'fixed', 'important'),
          t.style.setProperty('top', '0', 'important'),
          t.style.setProperty('left', '0', 'important'),
          t.style.setProperty('width', '100%'),
          t.style.setProperty('height', '100%'),
          t.style.setProperty('z-index', '2147483647', 'important'),
          t.style.setProperty('border', 'none', 'important'),
          (t.id = e),
          (t.type = 'text/html'),
          (t.allow = 'clipboard-write;xr-spatial-tracking;fullscreen');
        let o = 'Roomvo Visualizer, Powered by Roomvo';
        (t.title = o), (t.ariaLabel = o), (t.tabIndex = '-1'), document.body.appendChild(t);
      }
    },
    Gt = (e) => {
      e.style.setProperty('background-color', ''),
        e.style.setProperty('box-shadow', ''),
        e.style.setProperty('transform', ''),
        e.style.setProperty('transition', ''),
        e.style.setProperty('transition-delay', ''),
        e.style.setProperty('transition-duration', ''),
        e.style.setProperty('transition-property', ''),
        e.style.setProperty('transition-timing-function', '');
      let t = `popupStylized_${e.id.replace(/[^a-zA-Z0-9_]/g, '_')}`;
      if (document.head.dataset?.[t] !== 'true') {
        let o = [
          [
            `#${e.id}`,
            ['background-color', 'white', !0],
            ['box-shadow', '0px 0px 120px rgba(57, 59, 68, 0.30)', !0],
            ['transition', 'transform .75s cubic-bezier(0.95, 0, 1, 0.94)'],
            ['transform', 'translateY(110%)'],
          ],
          [
            `#${e.id}.roomvo-popup--show`,
            ['transform', 'translateY(0%) translateX(0%)', !0],
            ['transition-timing-function', 'cubic-bezier(0,.25,.29,1)', !0],
          ],
          [`#${e.id}.roomvo-popup--loading`, ['width', '1px', !0], ['height', '1px', !0]],
        ];
        be(o), (document.head.dataset[t] = 'true');
      }
      e.classList.add('roomvo-popup--loading'), (e.ariaHidden = !0);
    },
    Zi = (e, t = de.RIGHT) => {
      if (
        (Gt(e),
        e.style.setProperty('right', ''),
        e.style.setProperty('left', ''),
        document.head.dataset?.isDrawerPopupStylized !== 'true')
      ) {
        let o = [
            [`#${f}.roomvo-drawer.roomvo-drawer--${de.RIGHT}`, ['transform', 'translateX(110%)'], ['right', '0']],
            [`#${f}.roomvo-drawer.roomvo-drawer--${de.LEFT}`, ['transform', 'translateX(-110%)'], ['left', '0']],
          ],
          r = be(o);
        (document.head.dataset.isDrawerPopupStylized = 'true'),
          r.insertRule(`@media (min-width: 600px) {
                #${f}.roomvo-drawer { width: 500px !important; }
            }`);
      }
      e.classList.add('roomvo-drawer', `roomvo-drawer--${t}`);
    },
    Xi = (e, t) => {
      t?.addEventListener('load', () => Ye(e), { once: !0 });
    },
    Vt = (e = f) => {
      let t = document.getElementById(e);
      t && t.classList.contains('roomvo-popup--show')
        ? (t.addEventListener('transitionend', () => t.parentNode.removeChild(t)),
          t.classList.remove('roomvo-popup--show'))
        : t && t.parentNode && t.parentNode.removeChild(t),
        setTimeout(jt, 10);
    },
    Ht = (e) => {
      let t = document.getElementById(e);
      return t && t.dataset.previousBodyStyleOverflow;
    },
    Me = (e, t) => {
      let o = document.getElementById(e);
      return o && o.dataset[t];
    },
    Wt = (e) => {
      try {
        let t = window.getComputedStyle(document.body).getPropertyValue('overflow');
        t !== 'hidden' && ((e.dataset.previousBodyStyleOverflow = t), (document.body.style.overflow = 'hidden'));
      } catch {}
    },
    kt = (e, t, o) => {
      try {
        let r = window.getComputedStyle(e).getPropertyValue('overscroll-behavior');
        ['contain', 'none'].includes(r) || ((t.dataset[o] = r), (e.style.overscrollBehavior = 'contain'));
      } catch {}
    },
    x = (e) => (e ? e && e.src && e.contentWindow : !1),
    $t = (e, t, o = '', r = f, n = !0) => {
      if (e.isWebGlNeeded() && !gt())
        return alert('Your browser or device does not support WebGL. Please try a different browser or device.'), null;
      if (
        ((t = new URL(t)), (t.pathname += t.pathname.endsWith('/') ? '' : '/'), window.location.href == 'about:srcdoc')
      )
        return t.searchParams.delete('visitor_id'), window.open(t.href), null;
      t.searchParams.set('domain', g.getTopLevelHostname()),
        t.searchParams.set('is_in_top_window', 0),
        t.searchParams.set('version', '1'),
        n &&
          e.shouldPadHistory() &&
          !(window.history.state && window.history.state.roomvoPopupUrl) &&
          (t.searchParams.set('use_history_padding', 0),
          window.history.pushState(
            { roomvoPopupUrl: t.href, integratorVendorUrlPath: e.getVendorUrlPath(), loadPopupFunctionName: o },
            ''
          )),
        ji(r);
      let s = document.getElementById(r);
      return (
        s && s.parentNode == document.body && document.body.removeChild(s),
        (s.style.display = 'block'),
        { popup: s, popupUrl: t }
      );
    },
    V = (e, t) => {
      let { popup: o, popupUrl: r } = $t(e, t, 'loadPopupWithUrl');
      o &&
        (e.shouldShowLaunchSequence
          ? (Gt(o), Ft(e), Xi(e, o))
          : (o.style.background = `white url("${e.serverUrl}/static/images/loading.gif") no-repeat center`),
        (o.src = r.href),
        (o.dataset.openerVendorUrlPath = e.getVendorUrlPath()),
        document.body.appendChild(o),
        Wt(o),
        kt(document.body, o, 'previousBodyOverscrollBehavior'),
        kt(document.documentElement, o, 'previousRootOverscrollBehavior'),
        setTimeout(qt, 10, f));
    },
    zt = (e, t, o = de.RIGHT) => {
      let { popup: r, popupUrl: n } = $t(e, t, 'loadDrawerPopupWithUrl');
      r &&
        (Zi(r, o),
        r.addEventListener('load', (s) => ae(s.target), { once: !0 }),
        (r.src = n.href),
        (r.dataset.openerVendorUrlPath = e.getVendorUrlPath()),
        document.body.appendChild(r),
        Wt(r),
        setTimeout(qt, 10, f));
    };
  var Ji = () => Xe(y(), 'originator') ?? '';
  var Fe = async (e, t, o, r, n, s) => {
      (r === void 0 || r === '') && (r = '/'), n === void 0 && (n = ''), s == null && (s = '');
      let i = await e.getVisitorId({ vendorUrlPath: t }),
        a =
          e.serverUrl +
          '/my/' +
          t +
          r +
          '?visitor_id=' +
          encodeURIComponent(i) +
          '&tracking_code=' +
          encodeURIComponent(v(e)) +
          '&locale=' +
          encodeURIComponent(e.getLocale()) +
          '&prefilter=' +
          encodeURIComponent(e.prefilter) +
          n +
          '&iframe_id=' +
          f +
          '&originator=' +
          encodeURIComponent(Ji());
      e.agreedTermsOfUse && (a += '&agreed_terms_of_use=1');
      let c = G(e, o, s);
      c
        ? (a += '&product_ids=' + encodeURIComponent(c))
        : (a += '&product_code=' + encodeURIComponent(o) + '&product_type=' + encodeURIComponent(s)),
        V(e, a),
        e.trackActionInHostAnalytics('see this in my room', o);
    },
    H = async (e, t, o, r, n, s) => {
      try {
        s = s || e.getProductCode(t);
      } catch {
        s = '';
      }
      await Fe(e, e.getVendorUrlPathForStimr(), s, o, r, n);
    },
    pe = (e, t) => (o, r) => {
      e && !e.endsWith('/') && (e += '/');
      let n = o.getVendorUrlPath(),
        s = Object.entries(r).filter((a) => a[1] && t.includes(a[0])),
        i = new URLSearchParams(s);
      return i.set('version', '1'), i.sort(), `${o.serverUrl}/my/${n}/${e}?${i.toString()}`;
    },
    Qi = ['domain', 'iframe_id', 'is_in_top_window', 'locale', 'tracking_code', 'visitor_id'],
    Kc = pe('store_locator', Qi),
    ke = [
      'add_first_product_to_cart',
      'agreed_terms_of_use',
      'domain',
      'iframe_id',
      'is_in_top_window',
      'locale',
      'prefilter',
      'product_code',
      'product_id',
      'product_ids',
      'product_type',
      'tracking_code',
      'use_interim_products',
      'is_using_interim_products',
      'visitor_id',
      'is_standalone_shopping_cart',
    ],
    qc = pe('', ke),
    jc = pe('shopping_cart', ke);
  var ea = ['is_dealer', 'pro', 'is_embedded_in_site', 'show_request_estimate_form'].concat(ke),
    Zc = pe('catalog/list', ea);
  var Kt = async (e, t, o) => {
      let r = e.getVendorUrlPath(),
        n = await e.getVisitorId({ vendorUrlPath: r }),
        s = '/catalog';
      t = ta(t, o);
      let i =
        e.serverUrl +
        '/my/' +
        r +
        s +
        '?visitor_id=' +
        encodeURIComponent(n) +
        '&tracking_code=' +
        encodeURIComponent(v(e)) +
        '&locale=' +
        encodeURIComponent(e.getLocale()) +
        t +
        '&iframe_id=' +
        f;
      o && (i += '&product_id=' + o), V(e, i);
    },
    ta = (e = '', t, o = null) => {
      e = e || '';
      let r = o?.productType,
        n = o?.prefilter,
        s = new URLSearchParams(e);
      if (r) {
        let a = A(r);
        a !== U && s.set('product_type', a);
      }
      n && s.set('prefilter', n), (e = s.toString()), (e = e ? '&' + e : '');
      let i = new URL(y().href).searchParams;
      if (!t) {
        if (!e.includes('product_type') && i.get('product_type')) {
          let a = A(i.get('product_type'));
          a !== U && (e += `&product_type=${a}`);
        }
        !e.includes('product_code') && i.get('sku') && (e += `&product_code=${encodeURIComponent(i.get('sku'))}`),
          !e.includes('supplier_url_path') &&
            i.get('supplier') &&
            e.includes('product_code') &&
            (e += `&supplier_url_path=${i.get('supplier')}`);
      }
      return (
        !e.includes('prefilter') && i.get('prefilter') && (e += `&prefilter=${encodeURIComponent(i.get('prefilter'))}`),
        !e.includes('page') && i.get('page') && (e += `&page=${encodeURIComponent(i.get('page'))}`),
        e
      );
    };
  var qt = (e, t = 2147483647) => {
      let o = Array.from(document.querySelectorAll('*')).filter(function (r) {
        return window.getComputedStyle(r).getPropertyValue('z-index') == t;
      });
      for (let r = 0; r < o.length; ++r) {
        let n = o[r];
        n.id != e && (n.style.setProperty('z-index', t - 1, 'important'), (n.dataset.trampled = '1'));
      }
    },
    jt = (e = 2147483647) => {
      let t = Array.from(document.querySelectorAll('*')).filter(function (o) {
        return o.dataset.trampled == '1';
      });
      for (let o = 0; o < t.length; ++o) t[o].style.setProperty('z-index', e);
    },
    ue = (e, t, o) => {
      if (e.productCodeMap && t in e.productCodeMap && e.productCodeMap[t].length !== 0)
        if (o) {
          for (let r = 0; r < e.productCodeMap[t].length; ++r)
            if (e.productCodeMap[t][r].productType === o) return e.productCodeMap[t][r].product;
        } else return e.productCodeMap[t][0].product;
    };
  var Zt = () => {
    let e = document.getElementById(et);
    e && e.parentNode && e.parentNode.removeChild(e),
      setTimeout(jt, 10),
      window._roomvo.previouslyFocusedElement &&
        (window._roomvo.previouslyFocusedElement.focus(), delete window._roomvo.previouslyFocusedElement);
  };
  var _e = (e) =>
    String(e)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9 -]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  var Ge = (e, t, o, r = null, n = null) => {
    let s = new URL(e),
      i = o?.length === 1 ? o[0] : null;
    return (
      (s.pathname = ra(s.pathname, t, i, r, n)),
      s.searchParams.set('product_type', t),
      i && s.searchParams.set('product_subtype', i),
      r ? s.searchParams.set('product_id', r) : s.searchParams.delete('product_id'),
      s
    );
  };
  var ra = (e, t, o = null, r = null, n = null) => (
      (e = e.split('/catalog')[0].replace(/\/$/, '')),
      (n = r && n ? _e(n) + '--' + r : ''),
      (e = [e, 'catalog', na(t), sa(o), n].filter(Boolean).join('/')),
      e.endsWith('/') || (e += '/'),
      e
    ),
    na = (e) => {
      let t = Yt[e];
      return e === 7 && (t = 'Wall Decor'), (t = _e(t)), t;
    },
    sa = (e) => {
      if (!e) return '';
      let t = Mt[e];
      return t ? ((t = _e(t.replace('product_subtype.', '').replaceAll('_', ' ')).toLowerCase()), t) : '';
    };
  var Ve = (e, t) => {
      for (let o in t)
        o in e ||
          (Ut((r) => {
            !r || !r.data || !r.data.action || (r.data.action === o && t[o](r));
          }),
          (e[o] = t[o]));
    },
    eo = (e) => {
      e.onKeydownInWindow || (window.addEventListener('keydown', Xt), (e.onKeydownInWindow = Xt)),
        e.handleHostNavigation || (window.addEventListener('popstate', Qt), (e.handleHostNavigation = Qt));
      let t = {
        [P.SAVE_VISITOR]: ia,
        [P.ADD_TO_CART]: aa,
        [P.TRACK]: ca,
        [P.FOCUS_POPUP]: Jt,
        [P.FOCUS_IFRAME]: Jt,
        [P.CLOSE_PRODUCT_DISPLAY]: Zt,
        [P.LOAD_POPUP_FROM_PRODUCT_DISPLAY]: la,
        [P.AGREE_TO_TERMS_OF_USE]: pa,
        [P.OPEN_PRODUCT_VISUALIZER]: ua,
        [P.RESIZE_CATALOG]: _a,
        [P.OPEN_PRODUCT_PAGE]: ma,
        [P.OPEN_CATALOG]: Pa,
        [P.SCROLL_TOP_OF_IFRAME_INTO_VIEW]: Ea,
        [P.REQUEST_ESTIMATE]: ha,
        [P.UPDATE_PRODUCT_FILTER]: Ta,
        [P.DOWNLOAD_VISUALIZED_ROOM_IMAGE]: Ra,
      };
      Ve(e, t);
    },
    Xt = (e) => {
      let t = document.getElementById(f);
      if (e.key === 'Tab' && t && t.style.display !== 'none' && document.activeElement != t) {
        let o = { action: P.FOCUS_IFRAME };
        window.postMessage(o, '*');
      }
    },
    ia = (e) => {
      let t = h(e.data.integratorVendorUrlPath);
      t.setVisitorId(e.data.vendorUrlPath, e.data.visitorId, { overwriteExisting: !0 }),
        t.setVendorId(e.data.vendorUrlPath, e.data.vendorId, { overwriteExisting: !0 });
    },
    aa = (e) => {
      h(e.data.integratorVendorUrlPath).addToCart(e.data.customData, e.data.eventExtra);
    },
    ca = (e) => {
      h(e.data.integratorVendorUrlPath).trackActionInHostAnalytics(
        e.data.eventAction,
        e.data.eventLabel,
        e.data.eventExtra
      );
    },
    Jt = (e) => {
      let t = document.getElementById(f);
      t && t.focus();
    },
    la = (e) => {
      let t = h(e.data.integratorVendorUrlPath);
      Fe(t, e.data.vendorUrlPath, e.data.vendorCode, '', '', e.data.productType);
    },
    Qt = () => {
      let { roomvoPopupUrl: e, integratorVendorUrlPath: t, loadPopupFunctionName: o } = window.history.state || {};
      if (e && t && o) {
        let r = h(t),
          n = r.popupLoaders[o];
        n && n(r, e);
      } else {
        let r = da(),
          n = Ht(r);
        n && (document.body.style.overflow = n);
        let s = Me(r, 'previousBodyOverscrollBehavior');
        s && (document.body.style.overscrollBehavior = s);
        let i = Me(r, 'previousRootOverscrollBehavior');
        i && (document.documentElement.style.overscrollBehavior = i), Vt(r);
      }
    },
    da = () => {
      for (let e of mt) if (document.getElementById(e) && document.body.contains(document.getElementById(e))) return e;
      return f;
    },
    pa = () => {
      let e = h(event.data.integratorVendorUrlPath);
      O(e, 'write', { cookieName: j, cookieValue: !0 }), (e.agreedTermsOfUse = !0);
    },
    ua = async (e) => {
      let t = e.data.filters ? JSON.stringify(e.data.filters) : '',
        o = e.data.integratorVendorUrlPath,
        r = h(o),
        n = await r.getVisitorId({ vendorUrlPath: o }),
        s = new URL(`${r.serverUrl}/my/${o}`);
      s.searchParams.set('visitor_id', n),
        s.searchParams.set('locale', r.getLocale()),
        s.searchParams.set('product_id', e.data.productId),
        s.searchParams.set('iframe_id', F),
        s.searchParams.set('raw_prefilter', t),
        r.toString() === '[object AssistantIntegrator]' && s.searchParams.set('is_dealer', '1'),
        V(r, s.href);
    },
    _a = (e) => {
      document.getElementById(w).style.setProperty('min-height', `${e.data.height}px`, 'important');
      let t = h(e.data.integratorVendorUrlPath);
      e.data.isProductListOpen &&
        t._catalogScrollPosition &&
        (t._debouncedScroll ||
          (t._debouncedScroll = L(
            () => {
              let [o, r] = t._catalogScrollPosition;
              document.documentElement.scrollHeight < r ||
                (window.scroll(window.pageXOffset, o), (t._catalogScrollPosition = null));
            },
            150,
            !1
          )),
        t._debouncedScroll());
    },
    ma = (e) => {
      if (x(document.getElementById(w)) && !x(document.getElementById(F))) {
        let t = h(e.data.integratorVendorUrlPath);
        t._shouldRecordProductListScrollPosition &&
          (t._catalogScrollPosition = [window.pageYOffset, document.documentElement.scrollHeight]),
          document.getElementById('catalog').scrollIntoView(!0),
          (t._shouldRecordProductListScrollPosition = !1);
        let o = new URL(window.location.href);
        o.searchParams.set('product_id', e.data.productId);
        let r = o.href !== window.location.href;
        window.history.replaceState(window.history.state, '', o.href), r && t.trackPageView();
        let { productName: n, productId: s, productSubtype: i, productType: a, hasHumanReadableUrls: c } = e.data;
        if (c) {
          let l = Ge(window.location.href, a, [i], s, n);
          window.history.replaceState(window.history.state, '', l.href);
        }
      }
    },
    Ta = (e) => {
      if (x(document.getElementById(w)) && !x(document.getElementById(F))) {
        let { productType: t, productSubtypes: o, hasHumanReadableUrls: r } = e.data;
        if (r) {
          let n = Ge(window.location.href, t, o);
          window.history.replaceState(window.history.state, '', n.href);
        }
      }
    },
    Pa = (e) => {
      if (x(document.getElementById(w)) && !x(document.getElementById(F))) {
        let t = h(e.data.integratorVendorUrlPath);
        t._shouldRecordProductListScrollPosition = !0;
        let o = new URL(window.location.href);
        o.searchParams.delete('product_id');
        let r = o.href !== window.location.href;
        window.history.replaceState(window.history.state, '', o.href), r && t.trackPageView();
      }
    },
    Ea = (e) => {
      let t = e.data.iframeId;
      document.getElementById(t)?.scrollIntoView(!0);
    },
    ha = (e) => {
      x(document.getElementById(w)) &&
        e.data.yOffset &&
        window.scrollBy({
          top: document.getElementById(w)?.getBoundingClientRect().top + e.data.yOffset,
          behavior: 'smooth',
        });
    },
    Ra = (e) => {
      let t = document.createElement('a');
      (t.download = e.data.fileName),
        (t.href = e.data.href),
        (t.style.display = 'none'),
        document.body.appendChild(t),
        t.dispatchEvent(new MouseEvent('click', { bubbles: !1 })),
        document.body.removeChild(t);
    };
  var me = class {
      constructor() {
        (this.serverUrl = 'https://www.roomvo.com'),
          (this.visitorIds = {}),
          (this.vendorUrlPath = void 0),
          (this.vendorIds = {}),
          (this.productCodeMap = {}),
          (this.productShareLinkMap = {}),
          (this.queuedProductCodeRequests = {}),
          (this.queuedProductCodeRequestObjs = []),
          (this._registeredModules = new Set()),
          (this.prefilter = ''),
          (this.log = ''),
          (this.popupLoaders = { loadDrawerPopupWithUrl: zt, loadPopupWithUrl: V }),
          (this.trackPageViewDelay = 5 * 1e3),
          (this.standaloneAutolauncherConfigs = [
            {
              urlRegexObj: /\/roomvo\/?$/i,
              autolaunchConfirmationUrlParameter: 'roomvoAutoStart',
              productCodeUrlParameter: 'sku',
              supplierUrlPathParameter: null,
              vendorSlugUrlParameter: 'vendor_slug',
              productTypeUrlParameter: 'product_type',
              prefilterUrlParameter: 'prefilter',
              perProductTypePrefilterUrlParameter: 'per_product_type_prefilter',
              roomIdUrlParameter: 'room_id',
              standaloneFnName: 'startStandaloneVisualizer',
              requireConfirmation: !1,
            },
            {
              urlRegexObj: /\/roomvo-catalog\/?$/i,
              autolaunchConfirmationUrlParameter: 'roomvoAutoStart',
              productCodeUrlParameter: 'sku',
              supplierUrlPathParameter: null,
              vendorSlugUrlParameter: 'vendor_slug',
              productTypeUrlParameter: 'product_type',
              prefilterUrlParameter: 'prefilter',
              standaloneFnName: 'startProductCatalog',
              requireConfirmation: !1,
            },
            {
              urlRegexObj: /.*/i,
              requiredUrlParameters: ['roomvoStartKiosk'],
              autolaunchConfirmationUrlParameter: 'roomvoAutoStart',
              productCodeUrlParameter: 'sku',
              kioskPhysicalScannerUrlParameter: 'roomvoHasPhysicalScanner',
              standaloneFnName: 'startVisualizerInKioskMode',
              requireConfirmation: !1,
            },
            {
              urlRegexObj: /.*/i,
              requiredUrlParameters: ['roomvoStartVisualizer'],
              autolaunchConfirmationUrlParameter: 'roomvoAutoStart',
              productCodeUrlParameter: 'sku',
              supplierUrlPathParameter: 'supplier',
              productTypeUrlParameter: 'product_type',
              prefilterUrlParameter: 'prefilter',
              perProductTypePrefilterUrlParameter: 'per_product_type_prefilter',
              roomIdUrlParameter: 'room_id',
              vendorSlugUrlParameter: 'vendor_slug',
              hasRoomStyleTransferListUrlParameter: 'has_room_style_transfer_list',
              standaloneFnName: 'startStandaloneVisualizer',
              requireConfirmation: !1,
            },
          ]),
          (this.launchSequenceTimeoutDuration = 15 * 1e3),
          (this.launchSequenceLoaderBaseColor = '#818C98');
        let t = O(this, 'read/rewrite', { cookieName: Ie });
        t && (this.visitorIds = J(t));
        let o = O(this, 'read/rewrite', { cookieName: Se });
        o && (this.vendorIds = J(o));
        let r = O(this, 'read/rewrite', { cookieName: Ae });
        r && (this.vendorUrlPath = r),
          (this.agreedTermsOfUse = !!O(this, 'read', { cookieName: j })),
          this.isInAbExperimentMode() && ft(this.getCookieExpiration(), this),
          Object.defineProperty(this, 'getRoomvoListeners', {
            value: () => window._roomvo.roomvoListeners,
            writable: !1,
            configurable: !1,
          });
      }
      get [Symbol.toStringTag]() {
        return 'RoomvoIntegrator';
      }
      getVendorUrlPath() {
        return '';
      }
      shouldCommitVisitorToDb() {
        return !1;
      }
      getProductCode(t) {
        return 'code1';
      }
      set autolauncherConfig(t) {
        let o = this.standaloneAutolauncherConfigs.reduce((s, i) => ((s[i.standaloneFnName] = { ...i }), s), {}),
          r = [
            'startStandaloneVisualizer',
            'startProductCatalog',
            'startStandaloneSurfaceDesigner',
            'startVisualizerInKioskMode',
            'startMeasure',
            'addFavoriteProduct',
            'removeFavoriteProduct',
          ],
          n = (s) => {
            let i = s.standaloneFnName || 'startStandaloneVisualizer',
              c = { ...o[i], ...s },
              l = c.standaloneFnName;
            if (r.includes(l)) {
              let p = this.standaloneAutolauncherConfigs.find((m) => m.standaloneFnName === l);
              if (p) for (let m of Object.keys(p)) p[m] = c[m];
              else this.standaloneAutolauncherConfigs.push(c);
            } else d(this, `${l} is not a permitted autolaunch function`);
          };
        Array.isArray(t) ? t.forEach(n) : n(t);
      }
      getAppropriateAutolauncherConfig(t) {
        let o = fe(y());
        return this.standaloneAutolauncherConfigs.find((r) => {
          let {
            urlRegexObj: n,
            requiredUrlParameters: s,
            autolaunchConfirmationUrlParameter: i,
            vendorSlugUrlParameter: a,
            requireConfirmation: c,
          } = r;
          if (!n.test(o)) return !1;
          let l = t.get(i) || '';
          if (c && l.toLowerCase() !== 'true') return !1;
          let p = t.get(a) || '';
          return p && p !== this.getVendorUrlPath()
            ? !1
            : !s || s.every((m) => (t.get(m) || '').toLowerCase() === 'true');
        });
      }
      processAutolaunchVisualizer() {
        let t = new URL(y().href).searchParams,
          o = this.getAppropriateAutolauncherConfig(t);
        if (o) {
          let {
              productCodeUrlParameter: r,
              supplierUrlPathParameter: n,
              productTypeUrlParameter: s,
              prefilterUrlParameter: i,
              perProductTypePrefilterUrlParameter: a,
              roomIdUrlParameter: c,
              kioskPhysicalScannerUrlParameter: l,
              roomvoVisitorIdUrlParameter: p,
              hasRoomStyleTransferListUrlParameter: m,
              standaloneFnName: E,
            } = o,
            u = A(t.get(s)),
            _ = t.get(r),
            T = t.get(l),
            S = n && t.get(n),
            Y = a && t.get(a),
            I = m && t.get(m),
            C = S && _ ? `&supplier_url_path=${S}` : '';
          T === 'true' && (C += '&has_physical_scanner=1'),
            Y && (C += `&per_product_type_prefilter=${Y}`),
            I === '1'
              ? (C += '&has_room_style_transfer_list=1')
              : I === '0' && (C += '&has_room_style_transfer_list=0');
          let D = {};
          [i, c, p].forEach((he) => {
            let je = he && t.get(he);
            je && (D[he] = je);
          }),
            this[E](u, _, C, D);
        }
      }
      processAddToCartUrlParameter() {
        let t = new URL(y().href);
        if (t.searchParams.has(q) && Re(document.referrer) === Re(this.serverUrl)) {
          let o = t.searchParams.get(q);
          t.searchParams.delete(q), window.history.replaceState(null, '', t.href), this.addToCart({ productCode: o });
        }
      }
      onBodyLoaded() {}
      isWebGlNeeded() {
        return !0;
      }
      getLaunchSequenceClass() {
        return ie;
      }
      getVendorUrlPathForStimr() {
        return this.getVendorUrlPath();
      }
      getLocale() {
        return 'en-us';
      }
      getLocalizedStringOverrides() {
        return {};
      }
      getStimrButtonText(t) {
        return 'See It In My Room';
      }
      getCookieExpiration() {
        return 'Fri, 31 Dec 9999 23:59:59 GMT';
      }
      getCookieDomain() {
        return '';
      }
      getStimrTabIndex(t) {
        return 0;
      }
      shouldIncludeUpstreamProductMappings() {
        return !1;
      }
      addToCart(t, o) {}
      shouldPadHistory() {
        return !0;
      }
      isInAbExperimentMode() {
        return !1;
      }
      isRoomvoCookieDisabled() {
        return !!window.isRoomvoCookieDisabled;
      }
      shouldShowStimrButtons() {
        return !this.isInAbExperimentMode() || v(this) !== 'dontshow';
      }
      handleMeasureResult(t) {}
      handleRoomPageLiteSwipe(t) {}
      getRoomPageLiteRoomId(t, o) {
        return '';
      }
      trackActionInHostAnalytics(t, o, r) {
        try {
          let { ga4Ids: n } = fa();
          window.roomvoGtag('event', t, { event_category: 'Roomvo', event_label: o, send_to: n });
        } catch {}
      }
      async recordEvent(t, o = !1) {
        let r = {
          visitor_id: await this.getVisitorId(),
          vendor_id: await this.getVendorId(),
          device_type: Le(),
          entry_type: Ce,
        };
        t = Object.assign({}, r, t);
        let n = new FormData();
        for (let s in t) t[s] !== void 0 && t[s] !== null && n.append(s, t[s]);
        o && this.trackActionInHostAnalytics(t.event_name, '', t);
        try {
          await fetch(`${this.serverUrl}/services/event/events/`, { method: 'POST', body: n, keepalive: !0 });
        } catch {}
      }
      debug() {
        let t = document.querySelectorAll('.' + N),
          o = Array.from(t).filter((n) => n.style.visibility === 'hidden').length;
        console.group('Debug Information'),
          console.log(`%cSTIMRs:%c ${t.length} total, ${o} hidden`, 'font-weight: bold', ''),
          this._registeredModules &&
            console.log(
              `%cRegistered modules:%c ${Array.from(this._registeredModules).join(', ')}`,
              'font-weight: bold',
              ''
            );
        let r = this.getProductCode();
        r
          ? (console.log(`%cProduct code:%c ${r}`, 'font-weight: bold', ''),
            b(this, r, () => {
              this.productCodeMap[r] && this.productCodeMap[r].length !== 0
                ? console.log(`%cAvailable:%c ${r}`, 'font-weight: bold', '')
                : console.log(`%cNot available:%c ${r}`, 'font-weight: bold', ''),
                this.logPretty(),
                console.groupEnd();
            }))
          : (this.logPretty(), console.groupEnd());
      }
      logPretty() {
        console.group(
          `Log:%c ${
            this.log.split(`
`).length
          } lines`,
          'font-weight: normal'
        ),
          console.log(this.log),
          console.groupEnd();
      }
      startStandalone() {
        H(this);
      }
      async startVisualizerInKioskMode(t, o, r = '', n = {}) {
        let s = A(t);
        (r += '&is_in_kiosk_mode=1'), await H(this, void 0, o ? void 0 : '/kiosk', r, s === U ? '' : s, o);
      }
      async startStandaloneVisualizer(t, o, r = '', { prefilter: n, room_id: s } = {}) {
        let i = this.prefilter;
        n && (this.prefilter = n);
        let a = s ? `/rooms/${s}/` : void 0,
          c = A(t);
        await H(this, void 0, a, r, c === U ? '' : c, o), n && (this.prefilter = i);
      }
      async startProductCatalog(t, o, r = '', { prefilter: n } = {}) {
        let s = async () => {
          let i = A(t),
            a = ue(this, o, i);
          a || (o && (r += `&product_code=${encodeURIComponent(o)}`), i !== U && (r += `&product_type=${i}`)),
            n && (r += `&prefilter=${n}`),
            await Kt(this, r, a);
        };
        o && !this.productCodeMap?.[o] ? await b(this, o, s) : await s();
      }
      convertProductType(t) {
        return A(t);
      }
      setVisitorId(t, o, { overwriteExisting: r = !1 } = {}) {
        to(this, t, 'visitorIds', Ie, o, r);
      }
      setVendorId(t, o, { overwriteExisting: r = !1 } = {}) {
        to(this, t, 'vendorIds', Se, o, r);
      }
      async getVisitorId({ vendorUrlPath: t = this.getVendorUrlPath() } = {}) {
        try {
          return this.visitorIds[t] || (await Te(this, { vendorUrlPath: t })), this.visitorIds[t] ?? '';
        } catch {
          return '';
        }
      }
      async getVendorId({ vendorUrlPath: t = this.getVendorUrlPath() } = {}) {
        try {
          return this.vendorIds[t] || (await Te(this, { vendorUrlPath: t })), this.vendorIds[t] ?? '';
        } catch {
          return '';
        }
      }
      async addFavoriteProduct(t, o) {
        let r = new FormData();
        r.append('visitor', await this.getVisitorId()),
          r.append('vendor', await this.getVendorId()),
          r.append('sku', t),
          r.append('product_type', A(o)),
          fetch(`${this.serverUrl}/services/visitor/visitor_favorites/by_sku/`, { method: 'post', body: r });
      }
      async removeFavoriteProduct(t, o) {
        let r = new FormData();
        r.append('visitor', await this.getVisitorId()),
          r.append('vendor', await this.getVendorId()),
          r.append('sku', t),
          r.append('product_type', A(o)),
          fetch(`${this.serverUrl}/services/visitor/visitor_favorites/by_sku/`, { method: 'delete', body: r });
      }
      get vendorLogoUrl() {
        let t = new URL('/services/vendor/themes/asset/', this.serverUrl);
        return (
          t.searchParams.append('vendor_url_path', this.getVendorUrlPath()),
          t.searchParams.append('asset_name', 'my_landing_page_logo_background_image'),
          t.searchParams.append('locale', this.getLocale()),
          t
        );
      }
      get shouldShowLaunchSequence() {
        return !0;
      }
      getHostPageInfo() {
        let t = g.getUrl(),
          o = document.querySelector(`.${N}`),
          r = document.querySelector(`.${M}`),
          n = document.querySelector(`.${K}`),
          s = document.querySelector(`.${Qe}`);
        return {
          event_name: Pt,
          event_model_name: 'ViewedHostPageEvent',
          integration_type: r ? nt : rt,
          url: t.href.substring(0, 256),
          referrer_url: document.referrer.substring(0, 256),
          page_type: '',
          product_id: '',
          utm_source: t.searchParams.get('utm_source') || '',
          utm_medium: t.searchParams.get('utm_medium') || '',
          utm_campaign: t.searchParams.get('utm_campaign') || '',
          utm_content: t.searchParams.get('utm_content') || '',
          utm_term: t.searchParams.get('utm_term') || '',
          has_stimr: !!o,
          has_lite_integration: !!r,
          has_3d_display_integration: !!n,
          has_measure_integration: !!s,
        };
      }
      trackPageView() {
        setTimeout(() => {
          this.recordEvent(this.getHostPageInfo());
        }, this.trackPageViewDelay);
      }
      registerModules() {}
    },
    ro = async (e) => {
      if (ht(window.navigator) || Et(window.navigator)) return null;
      window._roomvo ||
        ((window._roomvo = {}), Object.defineProperty(window._roomvo, 'roomvoListeners', { value: {} })),
        window.roomvo || ((window.roomvo = {}), (window.ffViz = window.roomvo));
      let t = new e();
      if (t.getVendorUrlPath()) return oo(t);
      try {
        let r = await Te(t);
        return (
          (t.vendorUrlPath = r.vendorUrlPath), O(t, 'write', { cookieName: Ae, cookieValue: t.vendorUrlPath }), oo(t)
        );
      } catch {
        return null;
      }
    },
    He = new WeakMap(),
    Te = async (e, { timeout: t = null, vendorUrlPath: o } = {}) => {
      let r = o || e.getVendorUrlPath() || void 0,
        n;
      if (r) n = r;
      else {
        let a = g.getTopLevelHostname(),
          c = g.getNextLevelHostname();
        n = `${a}|${c}`;
      }
      He.has(e) || He.set(e, new Map());
      let s = He.get(e);
      if (s.has(n)) return s.get(n);
      let i = (async () => {
        let a = new AbortController(),
          c = t ? setTimeout(() => a.abort(), t) : null;
        try {
          let l = await fetch(`${e.serverUrl}/services/visitor/visitors/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
            body: JSON.stringify({
              vendor_url_path: r,
              locale: e.getLocale(),
              tracking_code: v(e),
              top_level_domain: g.getTopLevelHostname(),
              next_level_domain: g.getNextLevelHostname(),
              device_type: Le(),
              commit_to_db: e.shouldCommitVisitorToDb() === !0 ? !0 : void 0,
            }),
            signal: a.signal,
          });
          if ((c && clearTimeout(c), !l.ok)) throw new Error(`HTTP error! Status: ${l.status}`);
          let p = await l.json();
          return (
            e.setVisitorId(p.vendorUrlPath, p.id, { overwriteExisting: !1 }),
            e.setVendorId(p.vendorUrlPath, p.vendorId, { overwriteExisting: !1 }),
            p
          );
        } catch (l) {
          throw (c && clearTimeout(c), d(e, `${l.name} while retrieving visitor data. Message: ${l.message}`), l);
        }
      })();
      return (
        s.set(n, i),
        i.finally(() => {
          s.delete(n);
        })
      );
    },
    to = (e, t, o, r, n, s) => {
      xe(e[o]) && (e[o] = {});
      let i = O(e, 'read', { cookieName: r });
      i && (e[o] = J(i)),
        n && (s || !(t in e[o])) && (e[o][t] = n),
        O(e, 'write', { cookieName: r, cookieValue: B(e[o]) });
    },
    oo = async (e) => {
      if (e.getVendorUrlPath() in window._roomvo) {
        let t = window._roomvo[e.getVendorUrlPath()];
        if (e.toString() === t.toString()) return e;
      }
      if (
        ((window._roomvo[e.getVendorUrlPath()] = e),
        d(e, 'Roomvo log begins...'),
        e.getVendorUrlPath() &&
          (window.roomvo.startStandalone ||
            (window.roomvo.startStandalone = (t) => {
              h(t).startStandalone();
            }),
          window.roomvo.startStandaloneVisualizer ||
            (window.roomvo.startStandaloneVisualizer = (...t) => {
              (t = $e(...t)), h(t.splice(2, 1)[0]).startStandaloneVisualizer(...t);
            }),
          window.roomvo.startProductCatalog ||
            (window.roomvo.startProductCatalog = (...t) => {
              (t = $e(...t)), h(t.splice(2, 1)[0]).startProductCatalog(...t);
            }),
          window.roomvo.startVisualizerInKioskMode ||
            (window.roomvo.startVisualizerInKioskMode = (...t) => {
              (t = $e(...t)), h(t.splice(2, 1)[0]).startVisualizerInKioskMode(...t);
            }),
          window.roomvo.addFavoriteProduct ||
            (window.roomvo.addFavoriteProduct = (t, o, r) => {
              h(r).addFavoriteProduct(t, o);
            }),
          window.roomvo.removeFavoriteProduct ||
            (window.roomvo.removeFavoriteProduct = (t, o, r) => {
              h(r).removeFavoriteProduct(t, o);
            })),
        eo(window._roomvo.roomvoListeners),
        se(e),
        e.registerModules(),
        xe(e.visitorIds) || !(e.getVendorUrlPath() in e.visitorIds))
      )
        try {
          return await Te(e, { timeout: 1e4 }), We(e);
        } catch (t) {
          return t.name === 'AbortError' ? We(e) : null;
        }
      else return We(e);
    },
    We = async (e) => {
      if (!e.vendorIds[e.getVendorUrlPath()])
        throw new Error(`Failed to obtain vendor IDs for ${e.getVendorUrlPath()}`);
      let t = () => {
        ee(e) && e.processAddToCartUrlParameter(), e.processAutolaunchVisualizer(), e.onBodyLoaded(), e.trackPageView();
      };
      return (
        await new Promise((o) =>
          document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', o, { once: !0 }) : o()
        ),
        t(),
        e
      );
    },
    fa = () => {
      (window.dataLayer = window.dataLayer || []),
        window.roomvoGtag ||
          ((window.roomvoGtag = function () {
            window.dataLayer.push(arguments);
          }),
          window.roomvoGtag('js', new Date()));
      let e = [...document.querySelectorAll("head > script[src*='gtag']")]
        .map((t) => new URL(t.src).searchParams.get('id') || '')
        .filter((t) => t.startsWith('G-'));
      return { roomvoGtag: window.roomvoGtag, ga4Ids: e };
    },
    $e = (...e) => (
      e.length === 1 &&
        e[0] instanceof Object &&
        Object.prototype.toString.call(e[0]) === '[object Object]' &&
        (e = [e[0].productType, e[0].productCode, e[0].vendorUrlPath, e[0].extraParams, e[0].options]),
      e
    );
  var Oa = (e, t, o, r, n, s, i, a) => {
      n == null &&
        (n = function (u, _) {
          u.appendChild(_);
        }),
        (i = i || Je);
      let c = function (u) {
          d(e, `About to add buttons to containers: ${ce(u)}`);
          for (let _ of u) {
            let T = '';
            try {
              T = e.getProductCode(_);
            } catch (S) {
              d(e, `Exception getting product code on ${R(_)}: ${S.toString()}`);
              continue;
            }
            e.productCodeMap[T] === void 0
              ? (d(e, `Checking unknown: "${T}" on ${R(_)}`), b(e, T, () => l(_, T, s)))
              : l(_, T, s);
          }
        },
        l = function (u, _, T) {
          let S = () => {
              let I = le(e, u, _, T);
              if (I) {
                if (i === K && e.productCodeMap[_].every((C) => !C.is3dProductDisplayable))
                  return d(e, `3D product display not available for ${_}`), !1;
                if (i === tt && e.productCodeMap[_].every((C) => !C.isDesignerCompatible))
                  return d(e, `Designer not available for ${_}`), !1;
              }
              return I;
            },
            Y = function (I) {
              let C = I.querySelectorAll('.' + i);
              for (let D = 0; D < C.length; ++D) {
                let qe = 'productType' in C[D].dataset ? T == C[D].dataset.productType : !0;
                if (window.getComputedStyle(C[D]).visibility !== 'hidden' && qe) return C[D];
              }
              return null;
            };
          if (S()) {
            let I = Y(u);
            I ? I.dataset.roomvoProductCode !== _ && (I.dataset.roomvoProductCode = _) : p(u, _);
          } else m(u);
        },
        p = function (u, _) {
          let T = null;
          t ? ((T = t(e, s)), n(u, T)) : (T = u.querySelector('.' + i)),
            T
              ? ((T.style.visibility = 'visible'),
                T.classList.add(i),
                (T.dataset.active = 'true'),
                (T.dataset.roomvoProductCode = _),
                s && (T.dataset.productType = s),
                (T.onclick = a),
                Ca(e.getStimrTabIndex(T), T),
                d(e, `Added button to ${R(u)}`))
              : d(e, `Could not create or find existing button in ${R(u)}`);
        },
        m = function (u) {
          let _ = u.querySelectorAll('.' + i);
          for (let T = 0; T < _.length; ++T)
            t
              ? (!('productType' in _[T].dataset) || s == _[T].dataset.productType) &&
                (_[T].parentNode.removeChild(_[T]), d(e, `Removed button from ${R(u)}`))
              : ((_[T].style.visibility = 'hidden'),
                (_[T].dataset.active = 'false'),
                d(e, `Hid button inside ${R(u)}`));
        },
        E = [o];
      r && E.push(r),
        d(e, `Waiting for: ${E}`),
        k(document, E, function () {
          oe(document, o, c);
        });
    },
    Ca = (e, t) => {
      (t.tabIndex === void 0 || t.tabIndex === null || t.tabIndex < 0) && (t.tabIndex = e),
        (t.onkeydown = (o) => {
          (o.key === 'Enter' || o.key === ' ' || o.key === 'Space') && (o.preventDefault(), t.click());
        });
    },
    Ua = (e, t) => {
      let { appPath: o, productCode: r, productType: n } = t,
        s = {
          event_model_name: 'ClickedStimrButtonEvent',
          event_name: 'Clicked Stimr Button',
          app_path: o || '',
          locale: e.getLocale(),
          page_type: e.getHostPageInfo().page_type || '',
        };
      return (s.product_type = n || U), r && (s.product_code = r), s;
    },
    no = (e, t, o, r, n, s, i) => {
      e.shouldShowStimrButtons() &&
        Oa(e, t, o, r, n, s, N, function (c) {
          return (
            c.stopPropagation(),
            H(e, this, '', i, s),
            e.recordEvent(
              Ua(e, {
                appPath: '/',
                productType: c.currentTarget.dataset.productType,
                productCode: e.getProductCode(this),
              })
            ),
            !1
          );
        });
    };
  var so = 0.75,
    ga = 0.75,
    Sa = 3e3,
    Ia = 300,
    Aa = 100,
    ya = 100;
  function co(e) {
    if (e._registeredModules.has(Z)) {
      d(e, 'Roomvo Lite is already registered');
      return;
    }
    Ve(e.getRoomvoListeners(), ka),
      (e._registeredModules = e._registeredModules || new Set()),
      e._registeredModules.add(Z),
      d(e, 'Roomvo Lite is registered.');
  }
  var lo = (e, t, o, r, n, s) => {
      if (!e._registeredModules.has(Z)) {
        d(e, 'Roomvo Lite is not registered.');
        return;
      }
      if (!t) {
        d(e, 'ERROR: Missing room page lite iframe ID, cannot add room page lite iframe');
        return;
      }
      if (document.getElementById(t)) {
        d(e, `ERROR: Room page lite iframe #${t} already exists`);
        return;
      }
      let i = (c) => {
          d(e, `About to add room page lite iframe to containers: ${ce(c)}`);
          for (let l of c) {
            let p = '';
            try {
              p = e.getProductCode(l);
            } catch (E) {
              d(e, `Exception getting product code on ${R(l)}: ${E.toString()}`);
              continue;
            }
            let m = [e, l, p, n, t, s];
            e.productCodeMap[p] === void 0
              ? (d(e, `Checking unknown product code: ${p} on ${R(l)}`), b(e, p, () => ao(...m)))
              : ao(...m);
          }
        },
        a = [o];
      r && a.push(r),
        d(e, `Waiting for: ${a} to be available`),
        k(document, a, () => {
          oe(document, o, i);
        });
    },
    io = new WeakMap(),
    La = new FinalizationRegistry((e) => {
      try {
        e.callbacks.forEach((t) => t());
      } catch {}
    }),
    Ke = (e, ...t) => {
      let o = io.get(e);
      o || ((o = { callbacks: [] }), io.set(e, o), La.register(e, o)), o.callbacks.push(...t);
    },
    xa = (e, t) => {
      let o = e.querySelectorAll(`.${M}`);
      return t ? Array.from(o).some((r) => r.dataset.productType === t) : o.length > 0;
    },
    ao = async (e, t, o, r, n, s) => {
      if (!le(e, t, o, r)) return;
      let i = e.getVendorUrlPath(),
        a = await e.getVisitorId({ vendorUrlPath: i });
      if (xa(t, r)) return;
      let l = document.createElement('iframe');
      re(l),
        l.style.setProperty('width', '100%', 'important'),
        l.style.setProperty('height', '100%', 'important'),
        l.style.setProperty('border', 'none', 'important'),
        l.style.setProperty('visibility', 'inherit', 'important'),
        (l.id = n);
      let p = 'Roomvo Visualizer, Powered by Roomvo';
      (l.title = p),
        (l.ariaLabel = p),
        l.classList.add(M),
        (l.dataset.active = 'true'),
        (l.dataset.hasLoaded = 'false'),
        (l.dataset.productCode = o),
        r && (l.dataset.productType = r),
        (l.type = 'text/html'),
        (l.allow = 'clipboard-write;xr-spatial-tracking;fullscreen');
      let m =
        e.serverUrl +
        '/my/' +
        i +
        '/?layout=lite&visitor_id=' +
        encodeURIComponent(a) +
        '&tracking_code=' +
        encodeURIComponent(v(e)) +
        '&locale=' +
        encodeURIComponent(e.getLocale()) +
        '&prefilter=' +
        encodeURIComponent(e.prefilter) +
        '&iframe_id=' +
        n +
        '&domain=' +
        encodeURIComponent(g.getNextLevelHostname()) +
        '&version=1';
      e.agreedTermsOfUse && (m += '&agreed_terms_of_use=1');
      let E = e.getRoomPageLiteRoomId(o, r);
      E && (m += '&room_id=' + encodeURIComponent(E));
      let u = G(e, o, r);
      u
        ? (m += '&product_ids=' + encodeURIComponent(u))
        : (m += '&product_code=' + encodeURIComponent(o) + '&product_type=' + encodeURIComponent(r)),
        (l.src = m),
        t.appendChild(l),
        d(e, `Added room page lite iframe to ${R(t)}`),
        va({ integrator: e, roomPageLiteIframe: l, customRemoveRoomvoLiteHandler: s });
    },
    ze = (e, t = 0.75, o = 0) => {
      let r = !1,
        n = null;
      return (s) => {
        if (!r && s?.contentWindow) {
          if (!Be(s, t)) {
            n && (clearTimeout(n), (n = null));
            return;
          }
          if (!n) {
            if (o === 0) {
              s.contentWindow.postMessage(e, '*'), (r = !0);
              return;
            }
            (n = setTimeout(() => {
              (n = null), !r && s?.contentWindow && Be(s, t) && (s.contentWindow.postMessage(e, '*'), (r = !0));
            }, o)),
              Ke(s, () => {
                n && (clearTimeout(n), (n = null));
              });
          }
        }
      };
    },
    Da = (e) => {
      let { attributeName: t, oldValue: o, target: r } = e;
      if (['class', 'hidden', 'open'].includes(t)) return !0;
      let n = {};
      o?.split(';').forEach((i) => {
        if (i.includes(':')) {
          let [a, c] = i.split(':');
          a && c && (n[a.trim()] = c.trim());
        }
      });
      let s = r.style;
      return ['visibility', 'display', 'opacity'].some((i) => (n[i] || s[i]) && n[i] !== s[i]);
    },
    wa = (e, t) => {
      let o = L(() => t(), Aa);
      document.addEventListener('scroll', o, { passive: !0 });
      let r = L(t, ya),
        n = new MutationObserver((a) => {
          a.forEach((c) => {
            Da(c) && r();
          });
        }),
        s = e.parentElement;
      for (; s && s !== document.body; )
        n.observe(s, { attributeFilter: ['style', 'class', 'hidden', 'open'], attributeOldValue: !0 }),
          (s = s.parentElement);
      let i = L(() => t(), Ia);
      document.addEventListener('transitionend', i, { passive: !0 }),
        Ke(
          e,
          () => document.removeEventListener('scroll', o, { passive: !0 }),
          () => document.removeEventListener('transitionend', i, { passive: !0 }),
          () => n.disconnect()
        );
    },
    va = ({ integrator: e, roomPageLiteIframe: t, customRemoveRoomvoLiteHandler: o }) => {
      let r = { attributeFilter: ['data-product-code'], attributeOldValue: !0 },
        n = new MutationObserver((s) => {
          s.forEach((i) => {
            let { target: a, oldValue: c } = i,
              l = a.dataset.productCode;
            if (l === c) return;
            let p = G(e, l);
            if (p !== void 0) po(t, p);
            else {
              d(e, `Checking unknown product code: ${l}`);
              let m = [e, t, l, o];
              b(e, l, () => ba(...m));
            }
          });
        });
      n.observe(t, r), d(e, 'Listening for product code changes in Lite'), Ke(t, () => n.disconnect());
    },
    po = (e, t) => {
      if (e.dataset.hasLoaded === 'true')
        e.contentWindow.postMessage({ action: P.CHANGE_PRODUCT_CODE_IN_LITE, productIds: t }, '*');
      else {
        let o = new URL(e.src);
        o.searchParams.set('product_ids', t), (e.src = o.toString());
      }
    },
    ba = (e, t, o, r) => {
      let n = G(e, o);
      n
        ? po(t, n)
        : (d(e, `Failed to fetch product mappings for product code ${o}`),
          d(e, 'About to remove room page lite iframe container'),
          r ? r() : t.parentElement.remove(),
          d(e, 'Removed room page lite container'));
    },
    Pe = (e) => {
      let t = `#${e}.${M}`;
      return x(document.querySelector(t)) ? document.querySelector(t) : null;
    },
    Na = (e) => {
      let t = e.data.iframeId,
        o = Pe(t);
      o && ((o.dataset.isFullScreen = !0), yt(o));
    },
    Ba = (e) => {
      let t = e.data.iframeId,
        o = Pe(t);
      o && ((o.dataset.isFullScreen = !1), Lt(o));
    },
    Ya = (e) => {
      if (!['left', 'right'].includes(e.data.direction)) return;
      h(e.data.integratorVendorUrlPath).handleRoomPageLiteSwipe(e.data.direction);
    },
    Ma = (e) => {
      let t = e.data.iframeId,
        o = Pe(t);
      o &&
        ((o.dataset.hasLoaded = 'true'),
        uo(o, { includeRoomViewEvent: !0, includeProductImpressionEvent: !0, includeProductUsageEvent: !0 }));
    },
    Fa = (e) => {
      let t = e.data.iframeId,
        o = Pe(t);
      o && uo(o, { includeProductImpressionEvent: !0, includeProductUsageEvent: !0 });
    },
    uo = (
      e,
      { includeRoomViewEvent: t = !1, includeProductImpressionEvent: o = !1, includeProductUsageEvent: r = !1 } = {}
    ) => {
      let n = null,
        s = null,
        i = null;
      o && (s = ze(P.TRACK_PRODUCT_IMPRESSION_EVENT_FOR_LITE, so, 0)),
        r && (i = ze(P.TRACK_PRODUCT_USAGE_EVENT_FOR_LITE, ga, Sa)),
        t && (n = ze(P.TRACK_ROOM_PAGE_VIEW_FOR_LITE, so, 0));
      let a = (c) => {
        n && n(c), s && s(c), i && i(c);
      };
      a(e), wa(e, () => a(e));
    },
    ka = Object.freeze({
      [P.EXPAND_ROOM_PAGE_LITE]: Na,
      [P.SHRINK_ROOM_PAGE_LITE]: Ba,
      [P.SWIPE_ROOM_PAGE_LITE]: Ya,
      [P.NOTIFY_ROOM_PAGE_LITE_LOADED]: Ma,
      [P.NOTIFY_ROOM_PAGE_LITE_PRODUCT_UPDATED]: Fa,
    });
  var Ee = class extends me {
    getHostPageInfo() {
      let t = super.getHostPageInfo(),
        o = document.querySelector(`.${N}`),
        r = this.getProductCode(),
        n = Oe(y()),
        s = n[n.length - 1];
      if (
        (n.includes('products') && s != 'products'
          ? ((t.page_type = it), (t.product_code = r))
          : n.includes('')
          ? (t.page_type = ct)
          : n.includes('products') && s == 'products'
          ? (t.page_type = at)
          : n.includes('room-visualizer')
          ? (t.page_type = lt)
          : n.includes('cart') && n.includes('thank-you')
          ? (t.page_type = pt)
          : n.includes('cart')
          ? (t.page_type = dt)
          : (t.page_type = ut),
        o)
      ) {
        (t.integration_type = st), (t.has_stimr = !0), (t.product_code = r);
        let i = ue(this, r);
        t.product_id = i || '';
      }
      return t;
    }
    trackPageView() {
      setTimeout(() => {
        this.recordEvent(this.getHostPageInfo());
      }, 2e3);
    }
    getVendorUrlPath() {
      return 'nydreeflooring';
    }
    isWebGlNeeded() {
      return !1;
    }
    getProductCode(t) {
      let o = Ze(y()).toLowerCase(),
        r = document.querySelector('.color-option.active span');
      if (r) {
        let n = r.innerHTML.toLowerCase().split('(').shift().trim().replaceAll(' ', '-');
        return n ? `${o}_${n}` : o;
      }
      return o;
    }
    _reloadRoomvoLite() {
      let t = document.querySelector('.roomvo-lite-container'),
        o = this.getProductCode();
      if ((t && t.remove(), o)) {
        let r = this._createContainer();
        r.classList.add('roomvo-lite-container'),
          document.querySelector('.grid__item.product__media-wrapper .container').appendChild(r),
          lo(this, 'room-page-lite', '.roomvo-lite-container');
      }
    }
    registerModules() {
      co(this);
    }
    onBodyLoaded() {
      k(document, ['.product__media-wrapper', '.grid__item.product__media-wrapper .container'], () => {
        let t = () => {
            let s = (i, a) => {
              let c = document.querySelector('.product__media-inner .product__media-buttons');
              c ? c.before(a) : i.appendChild(a);
            };
            no(this, this._createStimr, '.product__media-wrapper .container .product__media-inner', null, s),
              this._reloadRoomvoLite();
          },
          o = document.querySelector('.swiper-wrapper'),
          r = null;
        new MutationObserver(() => {
          let s = document.querySelector('.swiper-slide-active .product__media-color'),
            i = s ? s.textContent.trim() : '';
          i && i !== r && ((r = i), t());
        }).observe(o, { attributes: !0, subtree: !0, attributeFilter: ['class'] }),
          t();
      });
    }
    _createStimr(t) {
      let o = document.createElement('button'),
        r = document.createElement('img');
      (r.src = 'https://www.roomvo.com/services/vendor/vendor_images/nydreeflooring/stimr_icon.png'),
        (r.style.width = '35px'),
        o.appendChild(r);
      let n = document.createElement('span');
      return (
        (n.innerText = t.getStimrButtonText()),
        (n.style.marginLeft = '15px'),
        o.appendChild(n),
        (o.style.marginTop = '6rem'),
        (o.style.width = '100%'),
        (o.style.height = '5rem'),
        o.classList.add('button', 'button--primary', 'button--quote'),
        o
      );
    }
    getStimrButtonText(t) {
      return 'See it in My Room';
    }
    _createContainer() {
      let t = document.createElement('div');
      return (
        (t.style.display = 'flex'),
        (t.style.width = '100%'),
        (t.style.height = '500px'),
        (t.style.marginTop = '5rem'),
        t
      );
    }
  };
  ro(Ee);
})();
